import React, { useState, useCallback } from "react";
import { 
  SuccessMessage,
  FailMessage,
  Loading,
  FormatValueToDecimal,
  CompanySelect,
  FormatDateToMDY,
  DateSelect,
  DateTimeSelect,
  FormatDateToWord,
  CustomerSelect,
  TermsSelect,
  ItemSelect,
  SalesInvoiceOptionalCustomerSelect,
  SalesmanSelect,
  CategorySelect
} from "../../common/APICommon";
import { apiUrl } from "../../utils/Configuration";
import axios from 'axios';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { PDFDocument } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import NoAccess from "../NoAccess";
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import SearchIcon from '@mui/icons-material/Search';

export default function SalesRegister() {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
//#endregion






//#region Variables 
  const [company, setCompany] = useState(null);
  // const today = new Date().toISOString().split("T")[0];
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [timeOfDeparture, setTimeOfDeparture] = useState(null);
  const [terms, setTerms] = useState("");
  const [category, setCategory] = useState(null);
  const [salesman, setSalesman] = useState(null);
  const [invoice, setInvoice] = useState(null);

  const [customer, setCustomer] = useState(null);
  const [showCustomerSelect, setShowCustomerSelect] = useState(false);

  const openCustomerSelect = () => {
    setShowCustomerSelect(true)
  }
  const closeCustomerSelect = () => {
    setShowCustomerSelect(false)
  }

  const [item, setItem] = useState(null);
  const [showItemSelect, setShowItemSelect] = useState(false);

  const openItemSelect = () => {
    setShowItemSelect(true)
  }
  const closeItemSelect = () => {
    setShowItemSelect(false)
  }
//#endregion






//#region Generate
  const fetchReportData = useCallback(async () => {
    const body = {
      dateFrom: dateFrom,
      dateTo: dateTo,
      customerId: customer ? customer?.customerId : null,
      itemCode: item ? item.itemCode : null,
      category: category ? category : null,
      salesmanCode: salesman ? salesman.salesmanCode : null,
      terms: terms ? terms : null,
      documentId: invoice ? invoice?.id : null,
      timeOfDeparture: timeOfDeparture ? timeOfDeparture : null
    }

    try {
      // const response = await axios.post(`${apiUrl}/api/Report/report-data/statement-of-account`, body, {
      const response = await axios.post(`${apiUrl}/api/Report/report-data/sales-register`, body, {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, [dateFrom, dateTo, customer, item, salesman, terms, timeOfDeparture, invoice, category]);

  // PDF
  const generateSalesRegisterByCustomerDetailedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byCustomerDetailed

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/SALES_REGISTER_BY_CUSTOMER_DETAILED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      // Original template (never modified)
      const templateDoc = await PDFDocument.load(templateBytes);
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const wrapText = (text, maxWidth, font, fontSize) => {
        if (!text) return [""];
        const words = text.split(" ");
        const lines = [];
        let currentLine = "";
        for (const word of words) {
          const testLine = currentLine ? `${currentLine} ${word}` : word;
          if (font.widthOfTextAtSize(testLine, fontSize) <= maxWidth) {
            currentLine = testLine;
          } else {
            if (currentLine) lines.push(currentLine);
            currentLine = word;
          }
        }
        if (currentLine) lines.push(currentLine);
        return lines;
      };

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        // Company Info
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        // Filters Info
        targetPage.drawText(customer?.customerName1?.toString() ?? "", { x: 74, y: 526, size: 8, font: calibriFont });
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 515, size: 8, font: calibriFont });
        targetPage.drawText(`${item?.itemCode?.toString() ?? ""} ${item?.itemDescription?.toString() ?? ""}`, { x: 57, y: 506, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 495, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 446;
      const bottomThreshold = 80;
      const colWidthDesc = 180;
      const lineHeight = 12;

      let grandGrossVatable = 0;
      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandAmount = 0;

      for (const record of _data) {
        for (const itemRow of record.items) {
          // --- PAGE BREAK CHECK ---
          if (yPosition < bottomThreshold) {
            const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
            currentPage = pdfDoc.addPage(templatePage);
            drawHeader(currentPage);
            yPosition = 446;
          }

          // Draw Row Data
          currentPage.drawText(FormatDateToMDY(record.date), { x: 35, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${record?.id ?? ""}`, { x: 85, y: yPosition, size: 8, font: calibriFont });

          const truncatedSalesman = truncateText(record?.salesman ?? "", 50, calibriFont, 8);
          currentPage.drawText(truncatedSalesman, { x: 160, y: yPosition, size: 8, font: calibriFont });

          const descLines = wrapText(itemRow.itemDescription, colWidthDesc, calibriFont, 8);
          for (let i = 0; i < descLines.length; i++) {
            currentPage.drawText(descLines[i], {
              x: 213,
              y: yPosition - i * lineHeight,
              size: 8,
              font: calibriFont,
            });
          }

          const qtyVal = parseFloat(itemRow.quantity) || 0;
          currentPage.drawText(`${FormatValueToDecimal(qtyVal)}`, { x: 302, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${itemRow.uomName ?? ""}`, { x: 330, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.unitPrice)}`, { x: 358, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.discountPercent)} %`, { x: 418, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalDiscount)}`, { x: 450, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.netPrice)}`, { x: 496, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 538, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 585, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vat)}`, { x: 628, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalAmount)}`, { x: 675, y: yPosition, size: 8, font: calibriFont });

          const rowHeight = Math.max(lineHeight, descLines.length * lineHeight);
          yPosition -= rowHeight + 5;

          grandGrossVatable += itemRow.vaTableSales || 0;
          grandVatable += itemRow.vaTableSales || 0;
          grandVatAmount += itemRow.vat || 0;
          grandAmount += itemRow.totalAmount || 0;
        }
      }

      // --- FOOTER SECTION ---
      if (yPosition < 150) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 446;
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
      yPosition -= 15;
      currentPage.drawText(`Customer Sub-Total:  `, { x: 35, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGrossVatable)}`, { x: 538, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 585, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 628, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 675, y: yPosition, size: 8, font: calibriBold });

      currentPage.drawLine({ start: { x: 35, y: yPosition - 10 }, end: { x: 757, y: yPosition - 10 }, thickness: 1 });
      yPosition -= 25;
      currentPage.drawText(`Grand Total:  `, { x: 35, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGrossVatable)}`, { x: 538, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 585, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 628, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 675, y: yPosition, size: 8, font: calibriBold });

      // --- PAGINATION POST-PROCESSING ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 680, 
          y: 580,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `SALES_REGISTER_BY_CUSTOMER_DETAILED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generateSalesRegisterByCustomerSummarizedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byCustomerSummarized

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/SALES_REGISTER_BY_CUSTOMER_SUMMARIZED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      // Original template (never modified)
      const templateDoc = await PDFDocument.load(templateBytes);
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const wrapText = (text, maxWidth, font, fontSize) => {
        if (!text) return [""];
        const words = text.split(" ");
        const lines = [];
        let currentLine = "";
        for (const word of words) {
          const testLine = currentLine ? `${currentLine} ${word}` : word;
          if (font.widthOfTextAtSize(testLine, fontSize) <= maxWidth) {
            currentLine = testLine;
          } else {
            if (currentLine) lines.push(currentLine);
            currentLine = word;
          }
        }
        if (currentLine) lines.push(currentLine);
        return lines;
      };

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        // Company Info
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        // Filters Info
        targetPage.drawText(customer?.customerName1?.toString() ?? "", { x: 74, y: 526, size: 8, font: calibriFont });
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 515, size: 8, font: calibriFont });
        targetPage.drawText(`${item?.itemCode?.toString() ?? ""} ${item?.itemDescription?.toString() ?? ""}`, { x: 57, y: 506, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 495, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 446;
      const bottomThreshold = 80;
      const colWidthDesc = 180;
      const lineHeight = 12;

      let grandGrossVatable = 0;
      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandAmount = 0;

      for (const record of _data) {
        // --- PAGE BREAK CHECK ---
        if (yPosition < bottomThreshold) {
          const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
          currentPage = pdfDoc.addPage(templatePage);
          drawHeader(currentPage);
          yPosition = 446;
        }

        // Draw Row Data
        currentPage.drawText(FormatDateToMDY(record.date), { x: 38, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${record?.id ?? ""}`, { x: 85, y: yPosition, size: 8, font: calibriFont });

        const truncatedSalesman = truncateText(record?.salesman ?? "", 100, calibriFont, 8);
        currentPage.drawText(truncatedSalesman, { x: 240, y: yPosition, size: 8, font: calibriFont });

        const descLines = wrapText(record.itemDescription, colWidthDesc, calibriFont, 8);
        for (let i = 0; i < descLines.length; i++) {
          currentPage.drawText(descLines[i], {
            x: 213,
            y: yPosition - i * lineHeight,
            size: 8,
            font: calibriFont,
          });
        }

        currentPage.drawText(`${record.terms ?? ""}`, { x: 360, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.grossVatable)}`, { x: 411, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.grossVatable)}`, { x: 493, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.vat)}`, { x: 557, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.amount)}`, { x: 625, y: yPosition, size: 8, font: calibriFont });

        const rowHeight = Math.max(lineHeight, descLines.length * lineHeight);
        yPosition -= rowHeight + 5;

        grandGrossVatable += record.grossVatable || 0;
        grandVatable += record.grossVatable || 0;
        grandVatAmount += record.vat || 0;
        grandAmount += record.amount || 0;
      }

      // --- FOOTER SECTION ---
      if (yPosition < 150) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 446;
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
      yPosition -= 15;
      currentPage.drawText(`Sub-Total:  `, { x: 35, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGrossVatable)}`, { x: 411, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 493, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 557, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 625, y: yPosition, size: 8, font: calibriBold });

      currentPage.drawLine({ start: { x: 35, y: yPosition - 10 }, end: { x: 757, y: yPosition - 10 }, thickness: 1 });
      yPosition -= 25;
      currentPage.drawText(`Grand Total:  `, { x: 35, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGrossVatable)}`, { x: 411, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 493, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 557, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 625, y: yPosition, size: 8, font: calibriBold });

      // --- PAGINATION POST-PROCESSING ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 680, 
          y: 580,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `SALES_REGISTER_BY_CUSTOMER_SUMMARIZED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generateSalesRegisterByCustomerSummarizedWithPercentageHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byCustomerSummarizedPercentage

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/SALES_REGISTER_BY_CUSTOMER_SUMMARIZED_WITH_PERCENTAGE.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      // Original template (never modified)
      const templateDoc = await PDFDocument.load(templateBytes);
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        // Company Info
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 761, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 751, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 741, size: 8, font: calibriFont });

        // Filters Info
        targetPage.drawText(customer?.customerName1?.toString() ?? "", { x: 73, y: 706, size: 8, font: calibriFont });
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 92, y: 695, size: 8, font: calibriFont });
        targetPage.drawText(`${item?.itemCode?.toString() ?? ""} ${item?.itemDescription?.toString() ?? ""}`, { x: 57, y: 685.5, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 674, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 633;
      const bottomThreshold = 80;

      let grandGrossSales = 0;
      let grandGrossVATable = 0;
      let grandVAT = 0;
      let grandNetSales = 0;
      let grandPercentage= 0;

      for (const record of _data) {
        // --- PAGE BREAK CHECK ---
        if (yPosition < bottomThreshold) {
          const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
          currentPage = pdfDoc.addPage(templatePage);
          drawHeader(currentPage);
          yPosition = 633;
        }

        // Draw Row Data
        const truncatedCustomer = truncateText(record?.customer ?? "", 50, calibriFont, 8);
        currentPage.drawText(truncatedCustomer, { x: 40, y: yPosition, size: 8, font: calibriFont });

        currentPage.drawText(`${FormatValueToDecimal(record.grossSales)}`, { x: 160, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.grossVATable)}`, { x: 250, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.vat)}`, { x: 350, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.netSales)}`, { x: 440, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.percentage)} %`, { x: 540, y: yPosition, size: 8, font: calibriFont });

        yPosition -= 10;

        grandGrossSales += record.grossSales || 0;
        grandGrossVATable += record.grossVATable || 0;
        grandVAT += record.vat || 0;
        grandNetSales += record.netSales || 0;
        grandPercentage += record.percentage || 0;
      }

      // --- FOOTER SECTION ---
      if (yPosition < 150) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 633;
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 35, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGrossSales)}`, { x: 160, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGrossVATable)}`, { x: 250, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVAT)}`, { x: 350, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandNetSales)}`, { x: 440, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandPercentage)} %`, { x: 540, y: yPosition, size: 8, font: calibriBold });

      // --- PAGINATION POST-PROCESSING ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 515, 
          y: 761,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `SALES_REGISTER_BY_CUSTOMER_SUMMARIZED_WITH_PERCENTAGE.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generateSalesRegisterByDateDetailedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byDateDetailed

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/SALES_REGISTER_BY_DATE_DETAILED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      // Original template (never modified)
      const templateDoc = await PDFDocument.load(templateBytes);
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const wrapText = (text, maxWidth, font, fontSize) => {
        if (!text) return [""];
        const words = text.split(" ");
        const lines = [];
        let currentLine = "";
        for (const word of words) {
          const testLine = currentLine ? `${currentLine} ${word}` : word;
          if (font.widthOfTextAtSize(testLine, fontSize) <= maxWidth) {
            currentLine = testLine;
          } else {
            if (currentLine) lines.push(currentLine);
            currentLine = word;
          }
        }
        if (currentLine) lines.push(currentLine);
        return lines;
      };

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        // Company Info
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        // Filters Info
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 515, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 505.5, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 456;
      const bottomThreshold = 80;
      const colWidthDesc = 180;
      const lineHeight = 20;

      let grandGrossVatable = 0;
      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandAmount = 0;

      for (const record of _data) {
        let subGrossVatable = 0; 
        let subVatable = 0;
        let subVatAmount = 0;
        let subAmount = 0;

        for (const itemRow of record.items) {
          // --- PAGE BREAK CHECK ---
          if (yPosition < bottomThreshold) {
            const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
            currentPage = pdfDoc.addPage(templatePage);
            drawHeader(currentPage);
            yPosition = 456;
          }

          // Draw Row Data
          currentPage.drawText(FormatDateToMDY(record.date), { x: 40, y: yPosition, size: 8, font: calibriFont });

          const descLines = wrapText(itemRow.itemDescription, colWidthDesc, calibriFont, 8);
          for (let i = 0; i < descLines.length; i++) {
            currentPage.drawText(descLines[i], {
              x: 40,
              y: (yPosition - 10) - i * lineHeight,
              size: 8,
              font: calibriFont,
            });
          }
          currentPage.drawText(`${record?.id ?? ""}`, { x: 100, y: yPosition, size: 8, font: calibriBold });

          const truncatedCustomer = truncateText(record?.customerName1 ?? "", 100, calibriFont, 8);
          currentPage.drawText(truncatedCustomer, { x: 150, y: yPosition, size: 8, font: calibriFont });

          const qtyVal = parseFloat(itemRow.quantity) || 0;
          currentPage.drawText(`${FormatValueToDecimal(qtyVal)}`, { x: 265, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${itemRow.uomName ?? ""}`, { x: 295, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(FormatValueToDecimal(itemRow.unitPrice), { x: 328, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalDiscount)}`, { x: 395, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.netPrice)}`, { x: 460, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 522, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 595, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vat)}`, { x: 650, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalAmount)}`, { x: 711, y: yPosition, size: 8, font: calibriFont });

          const rowHeight = Math.max(lineHeight, descLines.length * lineHeight);
          yPosition -= rowHeight + 5;

          subGrossVatable += itemRow.vaTableSales || 0;
          subVatable += itemRow.vaTableSales || 0;
          subVatAmount += itemRow.vat || 0;
          subAmount += itemRow.totalAmount || 0;

          grandGrossVatable += itemRow.vaTableSales || 0;
          grandVatable += itemRow.vaTableSales || 0;
          grandVatAmount += itemRow.vat || 0;
          grandAmount += itemRow.totalAmount || 0;
        }

          currentPage.drawLine({ start: { x: 35, y: yPosition + 10 }, end: { x: 757, y: yPosition + 10 }, thickness: 0.5 });

          currentPage.drawText(`Doc Total:  `, { x: 40, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subGrossVatable)}`, { x: 522, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subVatable)}`, { x: 595, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subVatAmount)}`, { x: 650, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subAmount)}`, { x: 711, y: yPosition, size: 8, font: calibriBold });

          yPosition -= 20;
      }

      // --- FOOTER SECTION ---
      if (yPosition < 150) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 456;
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 40, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGrossVatable)}`, { x: 522, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 595, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 650, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 711, y: yPosition, size: 8, font: calibriBold });

      // --- PAGINATION POST-PROCESSING ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 680, 
          y: 580,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `SALES_REGISTER_BY_DATE_DETAILED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };
  
  const generateSalesRegisterByDateSummarizedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byDateSummarized

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/SALES_REGISTER_BY_DATE_SUMMARIZED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      // Original template (never modified)
      const templateDoc = await PDFDocument.load(templateBytes);
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        // Company Info
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        // Filters Info
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 515, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 505.5, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 456;
      const bottomThreshold = 80;
      const lineHeight = 12;

      let grandGross = 0;
      let grandGrossVatable = 0;
      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandAmount = 0;

      for (const record of _data) {
        // --- PAGE BREAK CHECK ---
        if (yPosition < bottomThreshold) {
          const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
          currentPage = pdfDoc.addPage(templatePage);
          drawHeader(currentPage);
          yPosition = 456;
        }

        // Draw Row Data
        currentPage.drawText(FormatDateToMDY(record.date), { x: 35, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${record?.id ?? ""}`, { x: 85, y: yPosition, size: 8, font: calibriFont });

        const truncatedCustomer = truncateText(record?.customerName1 ?? "", 50, calibriFont, 8);
        currentPage.drawText(truncatedCustomer, { x: 128, y: yPosition, size: 8, font: calibriFont });

        currentPage.drawText(`${record?.terms ?? ""}`, { x: 229, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${record?.tin ?? ""}`, { x: 270, y: yPosition, size: 8, font: calibriFont });

        const truncatedSalesman = truncateText(record?.salesman ?? "", 50, calibriFont, 8);
        currentPage.drawText(truncatedSalesman, { x: 328, y: yPosition, size: 8, font: calibriFont });

        currentPage.drawText(`${FormatValueToDecimal(record.amount)}`, { x: 408, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.discounts)}`, { x: 460, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.grossVatable)}`, { x: 505, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.grossVatable)}`, { x: 555, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.vat)}`, { x: 606, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.amount)}`, { x: 665, y: yPosition, size: 8, font: calibriFont });

        yPosition -= lineHeight;

        grandGross += record.amount || 0;
        grandGrossVatable += record.grossVatable || 0;
        grandVatable += record.grossVatable || 0;
        grandVatAmount += record.vat || 0;
        grandAmount += record.amount || 0;
      
      }

      // --- FOOTER SECTION ---
      if (yPosition < 150) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 456;
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 35, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGross)}`, { x: 408, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGrossVatable)}`, { x: 505, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 555, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 606, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 665, y: yPosition, size: 8, font: calibriBold });

      // --- PAGINATION POST-PROCESSING ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 680, 
          y: 580,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `SALES_REGISTER_BY_DATE_SUMMARIZED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generateSalesRegisterByDocDetailedHandleClick = async () => {
    if (!company) {
      setFailMessage("Please fill up Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byDocNoDetailed

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/SALES_REGISTER_BY_DOC_NO_DETAILED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      // Original template (never modified)
      const templateDoc = await PDFDocument.load(templateBytes);
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const wrapText = (text, maxWidth, font, fontSize) => {
        if (!text) return [""];
        const words = text.split(" ");
        const lines = [];
        let currentLine = "";
        for (const word of words) {
          const testLine = currentLine ? `${currentLine} ${word}` : word;
          if (font.widthOfTextAtSize(testLine, fontSize) <= maxWidth) {
            currentLine = testLine;
          } else {
            if (currentLine) lines.push(currentLine);
            currentLine = word;
          }
        }
        if (currentLine) lines.push(currentLine);
        return lines;
      };

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        // Company Info
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        // Filters Info
        targetPage.drawText(invoice?.id?.toString() ?? "", { x: 70, y: 525.5, size: 8, font: calibriFont });
        targetPage.drawText(`${item?.itemCode?.toString() ?? ""} ${item?.itemDescription?.toString() ?? ""}`, { x: 57, y: 506, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 505.5, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 456;
      const bottomThreshold = 80;
      const colWidthDesc = 180;
      const lineHeight = 20;

      let grandGrossVatable = 0;
      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandAmount = 0;

      for (const record of _data) {
        let subGrossVatable = 0; 
        let subVatable = 0;
        let subVatAmount = 0;
        let subAmount = 0;

        for (const itemRow of record.items) {
          // --- PAGE BREAK CHECK ---
          if (yPosition < bottomThreshold) {
            const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
            currentPage = pdfDoc.addPage(templatePage);
            drawHeader(currentPage);
            yPosition = 456;
          }

          // Draw Row Data
          currentPage.drawText(`${record?.id ?? ""}`, { x: 40, y: yPosition, size: 8, font: calibriBold });

          const descLines = wrapText(itemRow.itemDescription, colWidthDesc, calibriFont, 8);
          for (let i = 0; i < descLines.length; i++) {
            currentPage.drawText(descLines[i], {
              x: 40,
              y: (yPosition - 10) - i * lineHeight,
              size: 8,
              font: calibriFont,
            });
          }
          currentPage.drawText(FormatDateToMDY(record.date), { x: 100, y: yPosition, size: 8, font: calibriFont });

          const truncatedCustomer = truncateText(record?.customerName1 ?? "", 100, calibriFont, 8);
          currentPage.drawText(truncatedCustomer, { x: 150, y: yPosition, size: 8, font: calibriFont });

          const qtyVal = parseFloat(itemRow.quantity) || 0;
          currentPage.drawText(`${FormatValueToDecimal(qtyVal)}`, { x: 265, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${itemRow.uomName ?? ""}`, { x: 295, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(FormatValueToDecimal(itemRow.unitPrice), { x: 328, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.discountPercent)} %`, { x: 380, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalDiscount)}`, { x: 421, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.netPrice)}`, { x: 466, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 516, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 580, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vat)}`, { x: 638, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalAmount)}`, { x: 695, y: yPosition, size: 8, font: calibriFont });

          const rowHeight = Math.max(lineHeight, descLines.length * lineHeight);
          yPosition -= rowHeight + 5;

          subGrossVatable += itemRow.vaTableSales || 0;
          subVatable += itemRow.vaTableSales || 0;
          subVatAmount += itemRow.vat || 0;
          subAmount += itemRow.totalAmount || 0;

          grandGrossVatable += itemRow.vaTableSales || 0;
          grandVatable += itemRow.vaTableSales || 0;
          grandVatAmount += itemRow.vat || 0;
          grandAmount += itemRow.totalAmount || 0;
        }

          currentPage.drawLine({ start: { x: 35, y: yPosition + 10 }, end: { x: 757, y: yPosition + 10 }, thickness: 0.5 });

          currentPage.drawText(`Sub Total:  `, { x: 40, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subGrossVatable)}`, { x: 516, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subVatable)}`, { x: 580, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subVatAmount)}`, { x: 638, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subAmount)}`, { x: 695, y: yPosition, size: 8, font: calibriBold });

          yPosition -= 20;
      }

      // --- FOOTER SECTION ---
      if (yPosition < 150) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 456;
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 40, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGrossVatable)}`, { x: 516, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 580, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 638, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 695, y: yPosition, size: 8, font: calibriBold });

      // --- PAGINATION POST-PROCESSING ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 680, 
          y: 580,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `SALES_REGISTER_BY_DOC_NO_DETAILED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generateSalesRegisterByDocSummarizedHandleClick = async () => {
    if (!company) {
      setFailMessage("Please fill up Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byDocNoSummarized

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/SALES_REGISTER_BY_DOC_NO_SUMMARIZED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      // Original template (never modified)
      const templateDoc = await PDFDocument.load(templateBytes);
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        // Company Info
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        // Filters Info
        targetPage.drawText(invoice?.id?.toString() ?? "", { x: 70, y: 525.5, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 505.5, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 456;
      const bottomThreshold = 80;
      const lineHeight = 12;

      let grandGrossVatable = 0;
      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandAmount = 0;

      for (const record of _data) {
        // --- PAGE BREAK CHECK ---
        if (yPosition < bottomThreshold) {
          const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
          currentPage = pdfDoc.addPage(templatePage);
          drawHeader(currentPage);
          yPosition = 456;
        }

        // Draw Row Data
        currentPage.drawText(`${record?.id ?? ""}`, { x: 40, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(FormatDateToMDY(record.date), { x: 83, y: yPosition, size: 8, font: calibriFont });

        const truncatedCustomer = truncateText(record?.customerName1 ?? "", 100, calibriFont, 8);
        currentPage.drawText(truncatedCustomer, { x: 180, y: yPosition, size: 8, font: calibriFont });

        currentPage.drawText(`${record?.terms ?? ""}`, { x: 315, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${record?.tin ?? ""}`, { x: 270, y: yPosition, size: 8, font: calibriFont });

        const truncatedSalesman = truncateText(record?.salesman ?? "", 100, calibriFont, 8);
        currentPage.drawText(truncatedSalesman, { x: 368, y: yPosition, size: 8, font: calibriFont });

        currentPage.drawText(`${FormatValueToDecimal(record.grossVatable)}`, { x: 485, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.grossVatable)}`, { x: 565, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.vat)}`, { x: 633, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.amount)}`, { x: 700, y: yPosition, size: 8, font: calibriFont });

        yPosition -= lineHeight;

        grandGrossVatable += record.grossVatable || 0;
        grandVatable += record.grossVatable || 0;
        grandVatAmount += record.vat || 0;
        grandAmount += record.amount || 0;
      
      }

      // --- FOOTER SECTION ---
      if (yPosition < 150) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 456;
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
      yPosition -= 15;
      currentPage.drawText(`Sub Total:  `, { x: 35, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGrossVatable)}`, { x: 485, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 565, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 633, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 700, y: yPosition, size: 8, font: calibriBold });

      currentPage.drawLine({ start: { x: 35, y: yPosition - 10 }, end: { x: 757, y: yPosition - 10 }, thickness: 0.5 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 35, y: yPosition - 10, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGrossVatable)}`, { x: 485, y: yPosition - 10, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 565, y: yPosition - 10, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 633, y: yPosition - 10, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 700, y: yPosition - 10, size: 8, font: calibriBold });

      // --- PAGINATION POST-PROCESSING ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 680, 
          y: 580,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `SALES_REGISTER_BY_DOC_NO_SUMMARIZED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generateSalesRegisterByItemDetailedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    
    // --- START OF GROUPING LOGIC ---
    // 1. Flatten the nested invoices/items and 2. Group them by ItemDescription
    const rawInvoices = allData?.byItemDetailed || [];
    
    if (rawInvoices.length === 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    const groupedMap = rawInvoices.flatMap(invoice => 
      (invoice.items || []).map(item => ({
        ...item,
        date: item.date,
        docId: item.docId, // Mapping invoice number to the row
        customer: item.customerName1,
        salesman: item.salesman,
        // Ensure field names match what the PDF loop expects below
        vaTableSales: item.vaTableSales || item.vatableSales || 0, 
        totalAmount: item.totalAmount || 0,
        vat: item.vat || 0
      }))
    ).reduce((acc, current) => {
      const key = current.itemDescription || "Unknown Item";
      if (!acc[key]) {
        acc[key] = {
          description: key,
          uomName: current.uomName,
          items: []
        };
      }
      acc[key].items.push(current);
      return acc;
    }, {});

    // Convert the map back to a sorted array for the PDF loop
    const _data = Object.values(groupedMap).sort((a, b) => a.description.localeCompare(b.description));
    // --- END OF GROUPING LOGIC ---

    try {
      const pdfUrl = `${window.location.origin}/docs/SALES_REGISTER_BY_ITEM_DETAILED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      // Original template (never modified)
      const templateDoc = await PDFDocument.load(templateBytes);

      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });
        targetPage.drawText(item?.itemDescription?.toString() ?? "", { x: 55, y: 526, size: 8, font: calibriFont });
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 515, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 505.5, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 446;
      const bottomThreshold = 80;
      const lineHeight = 12;

      let grandGrossVatable = 0;
      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandAmount = 0;

      for (const record of _data) {
        if (yPosition < 100) {
          const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
          currentPage = pdfDoc.addPage(templatePage);
          drawHeader(currentPage);
          yPosition = 446;
        }

        currentPage.drawText(`${record.description ?? "Unknown Item"}`, { x: 35, y: yPosition, size: 8, font: calibriBold });
        yPosition -= 12;
        currentPage.drawText(`SALES`, { x: 35, y: yPosition, size: 7, font: calibriFont });
        yPosition -= 15;

        let vendorVatable = 0;
        let vendorVat = 0;
        let vendorTotal = 0;
        let netQty = 0;

        for (const itemRow of record.items) {
          if (yPosition < bottomThreshold) {
            const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
            currentPage = pdfDoc.addPage(templatePage);
            drawHeader(currentPage);
            yPosition = 446;
          }

          currentPage.drawText(FormatDateToMDY(itemRow.date), { x: 35, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${itemRow?.docId ?? ""}`, { x: 85, y: yPosition, size: 8, font: calibriFont });

          const truncatedCustomer = truncateText(itemRow?.customer ?? "", 50, calibriFont, 8);
          currentPage.drawText(truncatedCustomer, { x: 129, y: yPosition, size: 8, font: calibriFont });

          const truncatedSalesman = truncateText(itemRow?.salesman ?? "", 50, calibriFont, 8);
          currentPage.drawText(truncatedSalesman, { x: 206, y: yPosition, size: 8, font: calibriFont });

          const qtyVal = parseFloat(itemRow.quantity) || 0;
          currentPage.drawText(`${FormatValueToDecimal(qtyVal)}`, { x: 291, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${itemRow.uomName ?? ""}`, { x: 317, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.unitPrice)}`, { x: 350, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.discountPercent)} %`, { x: 403, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalDiscount)}`, { x: 440, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.netPrice)}`, { x: 490, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 542, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 606, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vat)}`, { x: 664, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalAmount)}`, { x: 723, y: yPosition, size: 8, font: calibriFont });

          yPosition -= lineHeight;

          grandGrossVatable += itemRow.vaTableSales || 0;
          grandVatable += itemRow.vaTableSales || 0;
          grandVatAmount += itemRow.vat || 0;
          grandAmount += itemRow.totalAmount || 0;

          vendorVatable += itemRow.vaTableSales || 0;
          vendorVat += itemRow.vat || 0;
          vendorTotal += itemRow.totalAmount || 0;
          netQty += qtyVal;
        }

        currentPage.drawLine({ start: { x: 35, y: yPosition + 10 }, end: { x: 757, y: yPosition + 10 }, thickness: 0.5 });
        currentPage.drawText(`Item Sub-Total:`, { x: 35, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(vendorVatable)}`, { x: 542, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(vendorVatable)}`, { x: 606, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(vendorVat)}`, { x: 664, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(vendorTotal)}`, { x: 723, y: yPosition, size: 8, font: calibriBold });

        yPosition -= 12;
        currentPage.drawText(`Net Qty: ${FormatValueToDecimal(netQty)} ${record.uomName ?? ""}`, { x: 35, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`Sales: ${FormatValueToDecimal(vendorTotal)}`, { x: 204, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`Return: ${FormatValueToDecimal(0)}`, { x: 350, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`Net: `, { x: 606, y: yPosition, size: 8, font: calibriBold });
        yPosition -= 20; // Space before next item group
      }

      // --- FOOTER SECTION ---
      if (yPosition < 150) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 446;
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 35, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGrossVatable)}`, { x: 542, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 606, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 664, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 723, y: yPosition, size: 8, font: calibriBold });

      currentPage.drawText(`Sales: ${FormatValueToDecimal(grandAmount)}`, { x: 35, y: yPosition - 10, size: 8, font: calibriBold });
      currentPage.drawText(`Return: ${FormatValueToDecimal(0)}`, { x: 350, y: yPosition - 10, size: 8, font: calibriBold });
      currentPage.drawText(`Net: `, { x: 606, y: yPosition - 10, size: 8, font: calibriBold });

      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, { x: 680, y: 580, size: 10, font: calibriBold });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `SALES_REGISTER_BY_ITEM_DETAILED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generateSalesRegisterByItemSummarizedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    
    // --- START OF GROUPING LOGIC ---
    // 1. Flatten the nested invoices/items and 2. Group them by ItemDescription
    const _data = allData?.byItemDetailed || [];

    try {
      const pdfUrl = `${window.location.origin}/docs/SALES_REGISTER_BY_ITEM_SUMMARIZED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      // Original template (never modified)
      const templateDoc = await PDFDocument.load(templateBytes);

      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 756, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 746, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 736, size: 8, font: calibriFont });

        // Filters Info
        targetPage.drawText(`${item?.itemCode?.toString() ?? ""} ${item?.itemDescription?.toString() ?? ""}`, { x: 57, y: 706, size: 8, font: calibriFont });
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 90, y: 696, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 685.5, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 641;
      const bottomThreshold = 80;
      const lineHeight = 12;

      let grandSalesAmount = 0;
      let grandSalesReturnAmount = 0;
      let grandAmount = 0;

      for (const record of _data) {
        if (yPosition < bottomThreshold) {
          const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
          currentPage = pdfDoc.addPage(templatePage);
          drawHeader(currentPage);
          yPosition = 641;
        }

        const truncatedItem = truncateText(record?.description ?? "", 120, calibriFont, 8);
        currentPage.drawText(truncatedItem, { x: 40, y: yPosition, size: 8, font: calibriFont });

        const qtyVal = parseFloat(record.totalQuantity) || 0;
        currentPage.drawText(`${FormatValueToDecimal(qtyVal)} ${record.uomName ?? ""}`, { x: 160, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.totalAmount)}`, { x: 252, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.totalAmount)}`, { x: 537, y: yPosition, size: 8, font: calibriFont });

        yPosition -= lineHeight;

        grandSalesAmount += record.totalAmount || 0;
        grandAmount += record.totalAmount || 0;
      }

      // --- FOOTER SECTION ---
      if (yPosition < 150) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 641;
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 35, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandSalesAmount)}`, { x: 252, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandSalesReturnAmount)}`, { x: 440, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 537, y: yPosition, size: 8, font: calibriBold });

      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, { x: 680, y: 580, size: 10, font: calibriBold });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `SALES_REGISTER_BY_ITEM_SUMMARIZED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generateSalesRegisterByItemClassificationDetailedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    
    // Use the structure directly from the API/bulkData
    const categories = allData?.byItemClassificationDetailed || [];
    
    if (categories.length === 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/SALES_REGISTER_BY_ITEM_CLASSIFICATION_DETAILED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      const templateDoc = await PDFDocument.load(templateBytes);

      const pdfDoc = await PDFDocument.load(templateBytes);
      pdfDoc.registerFontkit(fontkit);
      
      const fontBytes = await fetch("/calibri.ttf").then(r => r.arrayBuffer());
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldBytes = await fetch("/calibrib.ttf").then(r => r.arrayBuffer());
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });
        
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 515, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 505.5, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 455;
      const bottomThreshold = 50;
      const lineHeight = 12;

      // Grand Totals
      let grandGrossVatable = 0;
      let grandDiscounts = 0;
      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandNetAmount = 0;

      for (const category of categories) {
        // Check for new page before Category Name
        if (yPosition < 100) {
          const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
          currentPage = pdfDoc.addPage(templatePage);
          drawHeader(currentPage);
          yPosition = 455;
        }

        // Draw Category Header (e.g., Mobilization, Cement)
        currentPage.drawText(category.categoryName || "No Category", { x: 35, y: yPosition, size: 8, font: calibriBold.italic ? calibriBold : calibriBold });
        yPosition -= 12;

        let categoryGrossVat = 0;
        let categoryDiscount = 0;
        let categoryVatable = 0;
        let categoryVat = 0;
        let categoryNet = 0;

        for (const itemGroup of category.items) {
          // Draw Item Description (e.g., Cement Type 1)
          currentPage.drawText(itemGroup.itemDescription || "", { x: 35, y: yPosition, size: 8, font: calibriFont.italic ? calibriFont : calibriFont });
          yPosition -= 10;

          for (const detail of itemGroup.details) {
            if (yPosition < bottomThreshold) {
              const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
              currentPage = pdfDoc.addPage(templatePage);
              drawHeader(currentPage);
              yPosition = 455;
            }

            const dateStr = detail.date ? FormatDateToMDY(detail.date) : "";
            currentPage.drawText(dateStr, { x: 35, y: yPosition, size: 7.5, font: calibriFont });
            currentPage.drawText(`${detail.docId || ""}`, { x: 83, y: yPosition, size: 7.5, font: calibriFont });
            
            currentPage.drawText(truncateText(detail.customer, 110, calibriFont, 7.5), { x: 132, y: yPosition, size: 7.5, font: calibriFont });
            currentPage.drawText(truncateText(detail.salesman, 75, calibriFont, 7.5), { x: 206, y: yPosition, size: 7.5, font: calibriFont });
            
            currentPage.drawText(FormatValueToDecimal(detail.quantity), { x: 292, y: yPosition, size: 7.5, font: calibriFont, align: 'right' });
            currentPage.drawText(detail.uomName || "", { x: 320, y: yPosition, size: 7.5, font: calibriFont });
            
            // Financials
            currentPage.drawText(`${FormatValueToDecimal(detail.netPrice)}`, { x: 365, y: yPosition, size: 7.5, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(detail.totalDiscount || 0)}`, { x: 426, y: yPosition, size: 7.5, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(detail.vaTableSales || 0)}`, { x: 490, y: yPosition, size: 7.5, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(detail.vaTableSales || 0)}`, { x: 562, y: yPosition, size: 7.5, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(detail.vat || 0)}`, { x: 630, y: yPosition, size: 7.5, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(detail.totalAmount || 0)}`, { x: 700, y: yPosition, size: 7.5, font: calibriFont });

            yPosition -= lineHeight;

            // Increment Category Totals
            categoryGrossVat += (detail.vaTableSales || 0);
            categoryDiscount += (detail.totalDiscount || 0);
            categoryVatable += (detail.vaTableSales || 0);
            categoryVat += (detail.vat || 0);
            categoryNet += (detail.totalAmount || 0);
          }
        }

        // Category Sub-Total Line
        currentPage.drawLine({ start: { x: 35, y: yPosition + 8 }, end: { x: 870, y: yPosition + 8 }, thickness: 0.5 });
        currentPage.drawText("Item Classification Sub-Total", { x: 35, y: yPosition, size: 8, font: calibriBold });
        
        currentPage.drawText(`${FormatValueToDecimal(categoryGrossVat)}`, { x: 365, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(categoryDiscount)}`, { x: 426, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(categoryVatable)}`, { x: 490, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(categoryVatable)}`, { x: 562, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(categoryVat)}`, { x: 630, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(categoryNet)}`, { x: 700, y: yPosition, size: 8, font: calibriBold });

        // Update Grand Totals
        grandGrossVatable += categoryGrossVat;
        grandDiscounts += categoryDiscount;
        grandVatable += categoryVatable;
        grandVatAmount += categoryVat;
        grandNetAmount += categoryNet;

        yPosition -= 20; // Space before next Category
      }

      // Final Grand Total
      if (yPosition < 80) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 455;
      }
      
      currentPage.drawLine({ start: { x: 35, y: yPosition + 10 }, end: { x: 870, y: yPosition + 10 }, thickness: 1 });
      currentPage.drawText("GRAND TOTAL", { x: 35, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGrossVatable)}`, { x: 365, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandDiscounts)}`, { x: 426, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 490, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 562, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 630, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandNetAmount)}`, { x: 700, y: yPosition, size: 8, font: calibriBold });

      // Page Numbers
      const allPages = pdfDoc.getPages();
      allPages.forEach((page, index) => {
        page.drawText(`Page : ${index + 1}`, { x: 820, y: 580, size: 9, font: calibriFont });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `SALES_REGISTER_BY_ITEM_CLASSIFICATION_SUMMARIZED_${FormatDateToMDY(new Date())}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generateSalesRegisterByItemClassificationSummarizedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    
    // Use the structure directly from the API/bulkData
    const categories = allData?.byItemClassificationDetailed || [];
    
    if (categories.length === 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/SALES_REGISTER_BY_ITEM_CLASSIFICATION_SUMMARIZED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      const templateDoc = await PDFDocument.load(templateBytes);

      const pdfDoc = await PDFDocument.load(templateBytes);
      pdfDoc.registerFontkit(fontkit);
      
      const fontBytes = await fetch("/calibri.ttf").then(r => r.arrayBuffer());
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldBytes = await fetch("/calibrib.ttf").then(r => r.arrayBuffer());
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const drawHeader = (targetPage) => {
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });
        
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 515, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 505.5, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 455;
      const bottomThreshold = 50;
      const lineHeight = 12;

      // Grand Totals
      let grandGrossVatable = 0;
      let grandDiscounts = 0;
      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandNetAmount = 0;

      for (const category of categories) {
        // Check for new page before Category Name
        if (yPosition < 100) {
          const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
          currentPage = pdfDoc.addPage(templatePage);
          drawHeader(currentPage);
          yPosition = 455;
        }

        // Draw Category Header (e.g., Mobilization, Cement)
        currentPage.drawText(category.categoryName || "No Category", { x: 35, y: yPosition, size: 8, font: calibriBold.italic ? calibriBold : calibriBold });
        yPosition -= 12;

        let categoryGrossVat = 0;
        let categoryDiscount = 0;
        let categoryVatable = 0;
        let categoryVat = 0;
        let categoryNet = 0;

        for (const itemGroup of category.items) {
          // Draw Item Description (e.g., Cement Type 1)
          currentPage.drawText(itemGroup.itemDescription || "", { x: 35, y: yPosition, size: 8, font: calibriFont.italic ? calibriFont : calibriFont });

          for (const detail of itemGroup.details) {
            if (yPosition < bottomThreshold) {
              const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
              currentPage = pdfDoc.addPage(templatePage);
              drawHeader(currentPage);
              yPosition = 455;
            }
            
            currentPage.drawText(FormatValueToDecimal(detail.quantity), { x: 230, y: yPosition, size: 7.5, font: calibriFont, align: 'right' });
            currentPage.drawText(detail.uomName || "", { x: 265, y: yPosition, size: 7.5, font: calibriFont });
            
            // Financials
            currentPage.drawText(`${FormatValueToDecimal(detail.netPrice)}`, { x: 305, y: yPosition, size: 7.5, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(detail.totalDiscount || 0)}`, { x: 386, y: yPosition, size: 7.5, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(detail.vaTableSales || 0)}`, { x: 460, y: yPosition, size: 7.5, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(detail.vaTableSales || 0)}`, { x: 540, y: yPosition, size: 7.5, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(detail.vat || 0)}`, { x: 617, y: yPosition, size: 7.5, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(detail.totalAmount || 0)}`, { x: 690, y: yPosition, size: 7.5, font: calibriFont });

            yPosition -= lineHeight;

            // Increment Category Totals
            categoryGrossVat += (detail.vaTableSales || 0);
            categoryDiscount += (detail.totalDiscount || 0);
            categoryVatable += (detail.vaTableSales || 0);
            categoryVat += (detail.vat || 0);
            categoryNet += (detail.totalAmount || 0);
          }
        }

        // Category Sub-Total Line
        currentPage.drawLine({ start: { x: 35, y: yPosition + 8 }, end: { x: 870, y: yPosition + 8 }, thickness: 0.5 });
        currentPage.drawText("Item Classification Sub-Total", { x: 35, y: yPosition, size: 8, font: calibriBold });
        
        currentPage.drawText(`${FormatValueToDecimal(categoryGrossVat)}`, { x: 305, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(categoryDiscount)}`, { x: 386, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(categoryVatable)}`, { x: 460, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(categoryVatable)}`, { x: 540, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(categoryVat)}`, { x: 617, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(categoryNet)}`, { x: 690, y: yPosition, size: 8, font: calibriBold });

        // Update Grand Totals
        grandGrossVatable += categoryGrossVat;
        grandDiscounts += categoryDiscount;
        grandVatable += categoryVatable;
        grandVatAmount += categoryVat;
        grandNetAmount += categoryNet;

        yPosition -= 20; // Space before next Category
      }

      // Final Grand Total
      if (yPosition < 80) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 455;
      }
      
      currentPage.drawLine({ start: { x: 35, y: yPosition + 10 }, end: { x: 870, y: yPosition + 10 }, thickness: 1 });
      currentPage.drawText("GRAND TOTAL", { x: 35, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGrossVatable)}`, { x: 305, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandDiscounts)}`, { x: 386, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 460, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 540, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 617, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandNetAmount)}`, { x: 690, y: yPosition, size: 8, font: calibriBold });

      // Page Numbers
      const allPages = pdfDoc.getPages();
      allPages.forEach((page, index) => {
        page.drawText(`Page : ${index + 1}`, { x: 820, y: 580, size: 9, font: calibriFont });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `SALES_REGISTER_BY_ITEM_CLASSIFICATION_SUMMARIZED_${FormatDateToMDY(new Date())}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generateSalesRegisterByPaymentReceivedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();

    // Flat data array from API/bulkData
    const mainData = allData?.byPaymentReceived || [];

    if (mainData.length === 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/SALES_REGISTER_BY_PAYMENT_RECEIVED.pdf`;
      const templateBytes = await fetch(pdfUrl).then((r) => r.arrayBuffer());
      const templateDoc = await PDFDocument.load(templateBytes);

      const pdfDoc = await PDFDocument.load(templateBytes);
      pdfDoc.registerFontkit(fontkit);

      const fontBytes = await fetch("/calibri.ttf").then((r) => r.arrayBuffer());
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldBytes = await fetch("/calibrib.ttf").then((r) => r.arrayBuffer());
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        const str = String(text);
        let currentWidth = font.widthOfTextAtSize(str, fontSize);
        if (currentWidth <= maxWidth) return str;
        const ellipsis = "...";
        let truncated = str;
        while (
          truncated.length > 0 &&
          font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth
        ) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      // Helper to draw right-aligned text (for numeric fields: Qty, Net Price, Amount)
      const drawRightText = (targetPage, text, rightX, y, size, font) => {
        if (text === null || text === undefined || text === "") return;
        const str = String(text);
        const textWidth = font.widthOfTextAtSize(str, size);
        targetPage.drawText(str, { x: rightX - textWidth, y, size, font });
      };

      const drawHeader = (targetPage) => {
        // Company info
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        // Period Cover & Date Printed (aligned next to pre-printed labels)
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, {
          x: 92,
          y: 515,
          size: 8,
          font: calibriFont,
        });
        targetPage.drawText(FormatDateToWord(new Date()), {
          x: 92,
          y: 505.5,
          size: 8,
          font: calibriFont,
        });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 455; // Starting Y coordinate below table header
      const bottomThreshold = 50;
      const lineHeight = 12;

      // Grand Totals
      let grandTotalAmount = 0;

      for (const item of mainData) {
        if (yPosition < bottomThreshold) {
          const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
          currentPage = pdfDoc.addPage(templatePage);
          drawHeader(currentPage);
          yPosition = 455;
        }

        const dateStr = item.date ? FormatDateToMDY(item.date) : "";
        const datePaidStr = item.datePaid ? FormatDateToMDY(item.datePaid) : "";

        // 1. Date
        currentPage.drawText(dateStr, { x: 38, y: yPosition, size: 7.5, font: calibriFont });

        // 2. Doc. No.
        currentPage.drawText(truncateText(item.docNo || "", 48, calibriFont, 7.5), {
          x: 82,
          y: yPosition,
          size: 7.5,
          font: calibriFont,
        });

        // 3. Customer
        currentPage.drawText(truncateText(item.customerName || "", 75, calibriFont, 7.5), {
          x: 127,
          y: yPosition,
          size: 7.5,
          font: calibriFont,
        });

        // 4. Qty (Right aligned)
        drawRightText(currentPage, FormatValueToDecimal(item.quantity || 0), 231, yPosition, 7.5, calibriFont);

        // 5. Item
        currentPage.drawText(truncateText(item.itemDescription || "", 70, calibriFont, 7.5), {
          x: 235,
          y: yPosition,
          size: 7.5,
          font: calibriFont,
        });

        // 6. Net Price (Right aligned)
        drawRightText(currentPage, FormatValueToDecimal(item.netPrice || 0), 359, yPosition, 7.5, calibriFont);

        // 7. U/M
        currentPage.drawText(truncateText(item.uomName || "", 28, calibriFont, 7.5), {
          x: 365,
          y: yPosition,
          size: 7.5,
          font: calibriFont,
        });

        // 8. Amount (Right aligned)
        drawRightText(currentPage, FormatValueToDecimal(item.totalAmount || 0), 445, yPosition, 7.5, calibriFont);

        // 9. Salesman
        currentPage.drawText(truncateText(item.salesman || "", 62, calibriFont, 7.5), {
          x: 450,
          y: yPosition,
          size: 7.5,
          font: calibriFont,
        });

        // 10. Date Paid
        currentPage.drawText(datePaidStr, { x: 523, y: yPosition, size: 7.5, font: calibriFont });

        // 11. Receipt No.
        currentPage.drawText(truncateText(item.receiptNo || "", 70, calibriFont, 7.5), {
          x: 580,
          y: yPosition,
          size: 7.5,
          font: calibriFont,
        });

        // 12. Payment Method
        currentPage.drawText(truncateText(item.paymentMethod || "", 60, calibriFont, 7.5), {
          x: 628,
          y: yPosition,
          size: 7.5,
          font: calibriFont,
        });

        // 13. Bank
        currentPage.drawText(truncateText(item.bank || "", 45, calibriFont, 7.5), {
          x: 682,
          y: yPosition,
          size: 7.5,
          font: calibriFont,
        });

        // 14. Check No
        currentPage.drawText(truncateText(item.checkNo || "", 50, calibriFont, 7.5), {
          x: 725,
          y: yPosition,
          size: 7.5,
          font: calibriFont,
        });

        // Accumulate totals
        grandTotalAmount += Number(item.totalAmount) || 0;

        yPosition -= lineHeight;
      }

      // Grand Total Row
      if (yPosition < 70) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 455;
      }

      // Top border line for Grand Total
      currentPage.drawLine({
        start: { x: 35, y: yPosition + 10 },
        end: { x: 770, y: yPosition + 10 },
        thickness: 1,
      });

      currentPage.drawText("GRAND TOTAL", { x: 38, y: yPosition, size: 8, font: calibriBold });
      drawRightText(currentPage, FormatValueToDecimal(grandTotalAmount), 445, yPosition, 8, calibriBold);

      // Double underline for accounting standard
      currentPage.drawLine({
        start: { x: 35, y: yPosition - 4 },
        end: { x: 770, y: yPosition - 4 },
        thickness: 0.5,
      });
      currentPage.drawLine({
        start: { x: 35, y: yPosition - 6.5 },
        end: { x: 770, y: yPosition - 6.5 },
        thickness: 0.5,
      });

      // Page Numbers
      const allPages = pdfDoc.getPages();
      allPages.forEach((page, index) => {
        page.drawText(`Page : ${index + 1}`, { x: 820, y: 580, size: 9, font: calibriFont });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `SALES_REGISTER_BY_PAYMENT_RECEIVED_${FormatDateToMDY(new Date())}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  //Excel
  const exportSalesRegisterByCustomerDetailedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      const _data = allData?.byCustomerDetailed;

      if (!_data || _data?.length <= 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sales Register Detailed');

      // 2. Add Company Header Information
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); // Gap

      // 3. Add Report Specific Info
      worksheet.addRow(['SALES REGISTER BY CUSTOMER (DETAILED)']).font = { bold: true };
      worksheet.addRow([`Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); // Gap

      // 4. Define Table Columns
      const headerRow = worksheet.addRow([
        'Date',
        'Doc. No.',
        'Ref. No.',
        'Salesman',
        'Item',
        'Qty',
        'UOM',
        'Gross Price',
        'Disc %',
        'Total Disc',
        'Net Price',
        'Gross VATable',
        'VATable Sales',
        'VAT',
        'Amount',
        'Remarks'
      ]);

      // Style the Header Row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = { bottom: { style: 'thin' } };
      });

      // 5. Add Data Rows
      let grandGrossVatable = 0;
      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandAmount = 0;

      _data.forEach(record => {
        record.items.forEach(itemRow => {
          const row = worksheet.addRow([
            FormatDateToMDY(record.date),
            record.id?.toString(),
            "",
            record.salesman,
            itemRow.itemDescription,
            parseFloat(itemRow.quantity || 0),
            itemRow.uomName,
            parseFloat(itemRow.unitPrice || 0),
            parseFloat(itemRow.discountPercent || 0) / 100, // Percentage format in Excel
            parseFloat(itemRow.totalDiscount || 0),
            parseFloat(itemRow.netPrice || 0),
            parseFloat(itemRow.vaTableSales || 0),
            parseFloat(itemRow.vaTableSales || 0),
            parseFloat(itemRow.vat || 0),
            parseFloat(itemRow.totalAmount || 0),
            "",
          ]);

          // Apply Number Formatting to currency columns
          const numberColumns = [5, 7, 9, 10, 11, 12, 13, 14];
          numberColumns.forEach(colIndex => {
            row.getCell(colIndex).numFmt = '#,##0.00';
          });
          row.getCell(8).numFmt = '0.00%'; // Discount % column

          // Accumulate totals
          grandGrossVatable += itemRow.vaTableSales || 0;
          grandVatable += itemRow.vaTableSales || 0;
          grandVatAmount += itemRow.vat || 0;
          grandAmount += itemRow.totalAmount || 0;
        });
      });

      // 6. Add Totals Footer
      worksheet.addRow([]); // Space before footer
      const footerRow = worksheet.addRow([
        'GRAND TOTAL', '', '', '', '', '', '', '', '', '', '',
        grandGrossVatable,
        grandVatable,
        grandVatAmount,
        grandAmount
      ]);

      footerRow.font = { bold: true };
      const footerIndices = [11, 12, 13, 14];
      footerIndices.forEach(idx => {
        footerRow.getCell(idx).numFmt = '#,##0.00';
        footerRow.getCell(idx).border = { top: { style: 'thin' }, bottom: { style: 'double' } };
      });

      // 7. Adjust Column Widths for readability
      worksheet.columns = [
        { width: 12 }, // Date
        { width: 10 }, // Ref ID
        { width: 15 }, // Salesman
        { width: 35 }, // Description
        { width: 10 }, // Qty
        { width: 8 },  // UOM
        { width: 12 }, // Unit Price
        { width: 10 }, // Disc %
        { width: 12 }, // Total Disc
        { width: 12 }, // Net Price
        { width: 15 }, // Gross VATable
        { width: 15 }, // VATable Sales
        { width: 12 }, // VAT
        { width: 15 }, // Total Amount
      ];

      // 8. Generate and Download File
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, `Sales_Register_Customer_Detailed_${new Date().getTime()}.xlsx`);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };

  const exportSalesRegisterByCustomerSummarizedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
        setFailMessage("Please fill up Date From, Date To, Company fields");
        return;
    }

    setLoading(true);
    try {
        const allData = await fetchReportData();
        const _data = allData?.byCustomerSummarized;

        if (!_data || _data?.length <= 0) {
            setFailMessage("No record found");
            setLoading(false);
            return;
        }

        // 1. Create Workbook and Worksheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sales Register');

        // 2. Company Information Section
        worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
        worksheet.addRow([company.address]);
        worksheet.addRow([`TIN: ${company.tin}`]);
        worksheet.addRow([]); // Gap

        // 3. Report Info Section
        worksheet.addRow(['SALES REGISTER BY CUSTOMER (SUMMARIZED)']).font = { bold: true };
        worksheet.addRow([`Customer:`, customer?.customerName1 || "ALL"]);
        worksheet.addRow([`Period:`, `${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
        worksheet.addRow([`Item:`, `${item?.itemDescription ?? ""}`]);
        worksheet.addRow([`Date Printed:`, FormatDateToWord(new Date())]);
        worksheet.addRow([]); // Gap

        // 4. Define Table Columns
        const headerRow = worksheet.addRow([
            'Date',
            'Doc. No.',
            'Ref. No.',
            'P.O. No.',
            'Salesman',
            'Terms',
            'Gross Vatable',
            'Vatable',
            'VAT Amount',
            'Amount',
            'Remarks'
        ]);

        // Style the Header Row
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
            cell.alignment = { horizontal: 'center' };
            cell.border = { bottom: { style: 'thin' } };
        });

        // 5. Add Data Rows
        let grandGross = 0, grandVat = 0, grandAmount = 0;

        _data.forEach(record => {
          console.log({record})
            const row = worksheet.addRow([
                FormatDateToMDY(record.date),
                record.id,
                "",
                "",
                record.salesman,
                record.terms,
                record.grossVatable,
                record.grossVatable, // Assuming Vatable = Gross based on your PDF logic
                record.vat,
                record.amount,
                ""
            ]);

            // Track Totals
            grandGross += record.grossVatable || 0;
            grandVat += record.vat || 0;
            grandAmount += record.amount || 0;

            // Align numeric cells to right
            row.getCell(6).numFmt = '#,##0.00';
            row.getCell(7).numFmt = '#,##0.00';
            row.getCell(8).numFmt = '#,##0.00';
            row.getCell(9).numFmt = '#,##0.00';
        });

        // 6. Add Footer / Totals
        worksheet.addRow([]); // Gap
        const totalRow = worksheet.addRow([
            'GRAND TOTAL', '', '', '', '', '',
            grandGross, 
            grandGross, 
            grandVat, 
            grandAmount
        ]);

        totalRow.eachCell((cell, colNumber) => {
            if (colNumber >= 1) cell.font = { bold: true };
            if (colNumber >= 6) cell.numFmt = '#,##0.00';
        });

        // 7. Column Widths
        worksheet.columns = [
            { width: 15 }, // Date
            { width: 12 }, // Doc No
            { width: 20 }, // Salesman
            { width: 35 }, // Description
            { width: 10 }, // Terms
            { width: 15 }, // Gross
            { width: 15 }, // Vatable
            { width: 15 }, // VAT
            { width: 15 }, // Total
        ];

        // 8. Generate and Save File
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `Sales_Register_Customer_Summarized_${new Date().getTime()}.xlsx`);

    } catch (error) {
        console.error("Excel Error:", error);
        setFailMessage("Error generating Excel file");
    } finally {
        setLoading(false);
    }
  };

  const exportSalesRegisterByCustomerSummarizedWithPercentageExcel = async () => {
    // 1. Validation (Matches your PDF logic)
    if (!dateFrom || !dateTo || !company) {
        setFailMessage("Please fill up Date From, Date To, Company fields");
        return;
    }

    setLoading(true);
    try {
        // 2. Fetch Data
        const allData = await fetchReportData();
        const _data = allData?.byCustomerSummarizedPercentage;

        if (!_data || _data?.length <= 0) {
            setFailMessage("No record found");
            setLoading(false);
            return;
        }

        // 3. Initialize Excel Workbook
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Summarized with Percentage');

        // 4. Header Section (Company & Filters)
        worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
        worksheet.addRow([company.address]);
        worksheet.addRow([`TIN: ${company.tin}`]);
        worksheet.addRow([]); // Blank line

        worksheet.addRow(['SALES REGISTER BY CUSTOMER (SUMMARIZED WITH PERCENTAGE)']).font = { bold: true };
        worksheet.addRow([`Customer:`, customer?.customerName1 || "ALL"]);
        worksheet.addRow([`Period:`, `${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
        worksheet.addRow([`Item:`, `${item?.itemCode ?? ""} ${item?.itemDescription ?? ""}`]);
        worksheet.addRow([`Date Printed:`, FormatDateToWord(new Date())]);
        worksheet.addRow([]); // Blank line

        // 5. Define Table Headers
        const headerRow = worksheet.addRow([
            'Customer',
            'Gross Sales',
            'Gross VATable',
            'VAT Amount',
            'Net Sales',
            'Percentage (%)'
        ]);

        // Style Table Headers
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } }; // Blue Theme
            cell.alignment = { horizontal: 'center' };
            cell.border = { bottom: { style: 'thin' } };
        });

        // 6. Data Rows
        let grandGrossSales = 0;
        let grandGrossVATable = 0;
        let grandVAT = 0;
        let grandNetSales = 0;
        let grandPercentage = 0;

        _data.forEach(record => {
            const row = worksheet.addRow([
                record.customer || "",
                record.grossSales || 0,
                record.grossVATable || 0,
                record.vat || 0,
                record.netSales || 0,
                (record.percentage || 0) / 100 // Convert to decimal for Excel percentage formatting
            ]);

            // Accumulate Totals
            grandGrossSales += record.grossSales || 0;
            grandGrossVATable += record.grossVATable || 0;
            grandVAT += record.vat || 0;
            grandNetSales += record.netSales || 0;
            grandPercentage += record.percentage || 0;

            // Apply Number Formatting
            row.getCell(2).numFmt = '#,##0.00';
            row.getCell(3).numFmt = '#,##0.00';
            row.getCell(4).numFmt = '#,##0.00';
            row.getCell(5).numFmt = '#,##0.00';
            row.getCell(6).numFmt = '0.00%'; // Formats as percentage in Excel
        });

        // 7. Grand Total Row
        worksheet.addRow([]); // Gap before total
        const totalRow = worksheet.addRow([
            'GRAND TOTAL',
            grandGrossSales,
            grandGrossVATable,
            grandVAT,
            grandNetSales,
            grandPercentage / 100
        ]);

        // Style Total Row
        totalRow.eachCell((cell, colIndex) => {
            cell.font = { bold: true };
            cell.border = { top: { style: 'thin' }, bottom: { style: 'double' } };
            if (colIndex >= 2 && colIndex <= 5) cell.numFmt = '#,##0.00';
            if (colIndex === 6) cell.numFmt = '0.00%';
        });

        // 8. Column Widths
        worksheet.columns = [
            { width: 40 }, // Customer
            { width: 18 }, // Gross Sales
            { width: 18 }, // Gross VATable
            { width: 15 }, // VAT Amount
            { width: 18 }, // Net Sales
            { width: 15 }, // Percentage
        ];

        // 9. Export and Download
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `Sales_Register_Percentage_${new Date().getTime()}.xlsx`);

    } catch (error) {
        console.error("Excel Export Error:", error);
        setFailMessage("Error generating Excel report");
    } finally {
        setLoading(false);
    }
  };

  const exportSalesRegisterByDateDetailedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
        setFailMessage("Please fill up Date From, Date To, Company fields");
        return;
    }

    setLoading(true);
    try {
        const allData = await fetchReportData();
        const _data = allData?.byDateDetailed;

        if (!_data || _data?.length <= 0) {
            setFailMessage("No record found");
            setLoading(false);
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Detailed Sales Register');

        // 1. Company & Report Headers
        worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
        worksheet.addRow([company.address]);
        worksheet.addRow([`TIN: ${company.tin}`]);
        worksheet.addRow([]); 
        
        worksheet.addRow(['SALES REGISTER BY DATE (DETAILED)']).font = { bold: true };
        worksheet.addRow([`Period:`, `${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
        worksheet.addRow([`Date Printed:`, FormatDateToWord(new Date())]);
        worksheet.addRow([]);

        // 2. Define Table Header
        const headerRow = worksheet.addRow([
            'Date',
            'Doc No',
            'Customer',
            'Item',
            'Qty',
            'UOM',
            'Unit Price',
            'Discount',
            'Net Price',
            'Gross Vatable',
            'Vatable',
            'VAT Amount',
            'Total Amount'
        ]);

        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
            cell.alignment = { horizontal: 'center' };
        });

        // 3. Data Processing
        let grandGross = 0, grandVatable = 0, grandVat = 0, grandAmount = 0;

        _data.forEach(record => {
            let subGross = 0, subVatable = 0, subVat = 0, subTotal = 0;

            // Add Item Rows
            record.items.forEach(item => {
                const row = worksheet.addRow([
                    FormatDateToMDY(record.date),
                    record.id,
                    record.customerName1,
                    item.itemDescription,
                    parseFloat(item.quantity) || 0,
                    item.uomName,
                    item.unitPrice,
                    item.totalDiscount,
                    item.netPrice,
                    item.vaTableSales, // Gross Vatable
                    item.vaTableSales, // Vatable
                    item.vat,
                    item.totalAmount
                ]);

                // Apply Number Formatting to data row
                [5, 7, 8, 9, 10, 11, 12, 13].forEach(col => {
                    row.getCell(col).numFmt = '#,##0.00';
                });

                // Increment Sub-totals
                subGross += item.vaTableSales || 0;
                subVatable += item.vaTableSales || 0;
                subVat += item.vat || 0;
                subTotal += item.totalAmount || 0;
            });

            // 4. Add "Doc Total" Row (Matching PDF logic)
            const subTotalRow = worksheet.addRow([
                'DOC TOTAL:', '', '', '', '', '', '', '', '', 
                subGross, 
                subVatable, 
                subVat, 
                subTotal
            ]);

            subTotalRow.eachCell((cell, colNumber) => {
                cell.font = { bold: true, italic: true };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F2F2F2' } };
                if (colNumber >= 10) cell.numFmt = '#,##0.00';
            });

            // Add a small gap between documents
            worksheet.addRow([]);

            // Increment Grand Totals
            grandGross += subGross;
            grandVatable += subVatable;
            grandVat += subVat;
            grandAmount += subTotal;
        });

        // 5. Grand Total Footer
        const grandTotalRow = worksheet.addRow([
            'GRAND TOTAL', '', '', '', '', '', '', '', '', 
            grandGross, 
            grandVatable, 
            grandVat, 
            grandAmount
        ]);

        grandTotalRow.eachCell((cell, colNumber) => {
            cell.font = { bold: true, size: 11 };
            cell.border = { top: { style: 'thin' }, bottom: { style: 'double' } };
            if (colNumber >= 10) cell.numFmt = '#,##0.00';
        });

        // 6. Set Column Widths
        worksheet.columns = [
            { width: 12 }, // Date
            { width: 12 }, // Doc No
            { width: 25 }, // Customer
            { width: 35 }, // Description
            { width: 10 }, // Qty
            { width: 8 },  // UOM
            { width: 12 }, // Unit Price
            { width: 12 }, // Discount
            { width: 12 }, // Net Price
            { width: 15 }, // Gross Vat
            { width: 15 }, // Vatable
            { width: 12 }, // Vat
            { width: 15 }, // Total
        ];

        // 7. Save File
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `Sales_Register_Detailed_${new Date().getTime()}.xlsx`);

    } catch (error) {
        console.error("Excel Export Error:", error);
        setFailMessage("Error generating Detailed Excel report");
    } finally {
        setLoading(false);
    }
  };

  const exportSalesRegisterByDateSummarizedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
        setFailMessage("Please fill up Date From, Date To, Company fields");
        return;
    }

    setLoading(true);
    try {
        const allData = await fetchReportData();
        const _data = allData?.byDateSummarized;

        if (!_data || _data?.length <= 0) {
            setFailMessage("No record found");
            setLoading(false);
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Summarized By Date');

        // 1. Company Header Info
        worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
        worksheet.addRow([company.address]);
        worksheet.addRow([`TIN: ${company.tin}`]);
        worksheet.addRow([]);

        // 2. Report Details
        worksheet.addRow(['SALES REGISTER BY DATE (SUMMARIZED)']).font = { bold: true };
        worksheet.addRow([`Period:`, `${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
        worksheet.addRow([`Date Printed:`, FormatDateToWord(new Date())]);
        worksheet.addRow([]);

        // 3. Define Headers
        const headerRow = worksheet.addRow([
            'Date',
            'Doc No',
            'Customer Name',
            'Terms',
            'Customer TIN',
            'Salesman',
            'Gross Amount',
            'Discounts',
            'Gross VATable',
            'VATable',
            'VAT Amount',
            'Total Amount'
        ]);

        // Style the headers
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '4472C4' } }; // Blue background
            cell.alignment = { horizontal: 'center' };
        });

        // 4. Populate Data Rows
        let grandGross = 0;
        let grandDiscounts = 0;
        let grandGrossVatable = 0;
        let grandVatable = 0;
        let grandVat = 0;
        let grandTotal = 0;

        _data.forEach(record => {
            const row = worksheet.addRow([
                FormatDateToMDY(record.date),
                record.id,
                record.customerName1,
                record.terms,
                record.tin,
                record.salesman,
                record.amount || 0,        // Gross Amount
                record.discounts || 0,     // Discounts
                record.grossVatable || 0,  // Gross Vatable
                record.grossVatable || 0,  // Vatable
                record.vat || 0,           // VAT
                record.amount || 0         // Total Amount
            ]);

            // Track totals
            grandGross += record.amount || 0;
            grandDiscounts += record.discounts || 0;
            grandGrossVatable += record.grossVatable || 0;
            grandVatable += record.grossVatable || 0;
            grandVat += record.vat || 0;
            grandTotal += record.amount || 0;

            // Apply number formatting to numeric columns (Columns 7 through 12)
            for (let i = 7; i <= 12; i++) {
                row.getCell(i).numFmt = '#,##0.00';
            }
        });

        // 5. Grand Total Row
        worksheet.addRow([]); // Blank row before total
        const totalRow = worksheet.addRow([
            'GRAND TOTAL', '', '', '', '', '',
            grandGross,
            grandDiscounts,
            grandGrossVatable,
            grandVatable,
            grandVat,
            grandTotal
        ]);

        totalRow.eachCell((cell, colNumber) => {
            cell.font = { bold: true };
            if (colNumber >= 7) {
                cell.numFmt = '#,##0.00';
                cell.border = { top: { style: 'thin' }, bottom: { style: 'double' } };
            }
        });

        // 6. Set Column Widths
        worksheet.columns = [
            { width: 12 }, // Date
            { width: 12 }, // Doc No
            { width: 30 }, // Customer Name
            { width: 10 }, // Terms
            { width: 15 }, // TIN
            { width: 20 }, // Salesman
            { width: 15 }, // Gross Amount
            { width: 12 }, // Discounts
            { width: 15 }, // Gross Vatable
            { width: 15 }, // Vatable
            { width: 15 }, // VAT Amount
            { width: 15 }, // Total Amount
        ];

        // 7. Generate Buffer and Download
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `Sales_Register_Date_Summarized_${new Date().getTime()}.xlsx`);

    } catch (error) {
        console.error("Excel Export Error:", error);
        setFailMessage("Error generating Excel report");
    } finally {
        setLoading(false);
    }
  };

  const exportSalesRegisterByDocDetailedExcel = async () => {
    // 1. Validation
    if (!company) {
        setFailMessage("Please fill up Company fields");
        return;
    }

    setLoading(true);
    try {
        // 2. Fetch Data
        const allData = await fetchReportData();
        const _data = allData?.byDocNoDetailed;

        if (!_data || _data?.length <= 0) {
            setFailMessage("No record found");
            setLoading(false);
            return;
        }

        // 3. Setup Workbook & Worksheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Doc Detailed Register');

        // 4. Header Section
        worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
        worksheet.addRow([company.address]);
        worksheet.addRow([`TIN: ${company.tin}`]);
        worksheet.addRow([]);

        worksheet.addRow(['SALES REGISTER BY DOCUMENT NO. (DETAILED)']).font = { bold: true };
        worksheet.addRow([`Document No:`, invoice?.id?.toString() || "N/A"]);
        worksheet.addRow([`Item:`, `${item?.itemCode ?? ""} ${item?.itemDescription ?? ""}`]);
        worksheet.addRow([`Date Printed:`, FormatDateToWord(new Date())]);
        worksheet.addRow([]);

        // 5. Table Headers
        const headerRow = worksheet.addRow([
            'Doc No',
            'Date',
            'Customer Name',
            'Item Description',
            'Qty',
            'UOM',
            'Unit Price',
            'Disc %',
            'Total Discount',
            'Net Price',
            'Gross VATable',
            'VATable',
            'VAT Amount',
            'Total Amount'
        ]);

        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '4472C4' } };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        // 6. Data Iteration
        let grandGrossVatable = 0;
        let grandVatable = 0;
        let grandVatAmount = 0;
        let grandAmount = 0;

        _data.forEach(record => {
            let subGross = 0, subVat = 0, subTotal = 0;

            record.items.forEach(itemRow => {
                const row = worksheet.addRow([
                    record.id,
                    FormatDateToMDY(record.date),
                    record.customerName1,
                    itemRow.itemDescription,
                    parseFloat(itemRow.quantity) || 0,
                    itemRow.uomName,
                    itemRow.unitPrice,
                    (itemRow.discountPercent || 0) / 100, // Convert to decimal for Excel % format
                    itemRow.totalDiscount,
                    itemRow.netPrice,
                    itemRow.vaTableSales,
                    itemRow.vaTableSales,
                    itemRow.vat,
                    itemRow.totalAmount
                ]);

                // Apply Number Formatting
                [5, 7, 9, 10, 11, 12, 13, 14].forEach(col => {
                    row.getCell(col).numFmt = '#,##0.00';
                });
                row.getCell(8).numFmt = '0.00%'; // Discount % column

                // Accumulate Sub-totals
                subGross += itemRow.vaTableSales || 0;
                subVat += itemRow.vat || 0;
                subTotal += itemRow.totalAmount || 0;
            });

            // Add Sub Total Row for this Document
            const subTotalRow = worksheet.addRow([
                'SUB TOTAL:', '', '', '', '', '', '', '', '', '', 
                subGross, 
                subGross, 
                subVat, 
                subTotal
            ]);

            subTotalRow.eachCell((cell, colIdx) => {
                cell.font = { bold: true, italic: true };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F2F2F2' } };
                if (colIdx >= 11) cell.numFmt = '#,##0.00';
            });

            worksheet.addRow([]); // Gap between documents

            // Accumulate Grand Totals
            grandGrossVatable += subGross;
            grandVatable += subGross;
            grandVatAmount += subVat;
            grandAmount += subTotal;
        });

        // 7. Grand Total Row
        const grandTotalRow = worksheet.addRow([
            'GRAND TOTAL', '', '', '', '', '', '', '', '', '', 
            grandGrossVatable, 
            grandVatable, 
            grandVatAmount, 
            grandAmount
        ]);

        grandTotalRow.eachCell((cell, colIdx) => {
            cell.font = { bold: true };
            if (colIdx >= 11) {
                cell.numFmt = '#,##0.00';
                cell.border = { top: { style: 'thin' }, bottom: { style: 'double' } };
            }
        });

        // 8. Column Widths
        worksheet.columns = [
            { width: 12 }, // Doc No
            { width: 12 }, // Date
            { width: 25 }, // Customer
            { width: 35 }, // Description
            { width: 10 }, // Qty
            { width: 8 },  // UOM
            { width: 12 }, // Unit Price
            { width: 10 }, // Disc %
            { width: 12 }, // Total Discount
            { width: 12 }, // Net Price
            { width: 15 }, // Gross Vat
            { width: 15 }, // Vatable
            { width: 12 }, // Vat
            { width: 15 }, // Total
        ];

        // 9. Export File
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `Sales_Register_Doc_${invoice?.id ?? ""}_${new Date().getTime()}.xlsx`);

    } catch (error) {
        console.error("Excel Error:", error);
        setFailMessage("Error generating Doc Detailed Excel");
    } finally {
        setLoading(false);
    }
  };

  const exportSalesRegisterByDocSummarizedExcel = async () => {
    // 1. Validation
    if (!company) {
        setFailMessage("Please fill up Company fields");
        return;
    }

    setLoading(true);
    try {
        // 2. Fetch Data
        const allData = await fetchReportData();
        const _data = allData?.byDocNoSummarized;

        if (!_data || _data?.length <= 0) {
            setFailMessage("No record found");
            setLoading(false);
            return;
        }

        // 3. Create Workbook
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Summarized By Doc');

        // 4. Report Header Section
        worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
        worksheet.addRow([company.address]);
        worksheet.addRow([`TIN: ${company.tin}`]);
        worksheet.addRow([]);

        worksheet.addRow(['SALES REGISTER BY DOCUMENT NO. (SUMMARIZED)']).font = { bold: true };
        worksheet.addRow([`Document No:`, invoice?.id?.toString() || "N/A"]);
        worksheet.addRow([`Date Printed:`, FormatDateToWord(new Date())]);
        worksheet.addRow([]);

        // 5. Define Table Headers
        const headerRow = worksheet.addRow([
            'Doc No',
            'Date',
            'Customer Name',
            'Terms',
            'TIN',
            'Salesman',
            'Gross VATable',
            'VATable',
            'VAT Amount',
            'Total Amount'
        ]);

        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '4472C4' } }; // Standard Blue Theme
            cell.alignment = { horizontal: 'center' };
        });

        // 6. Data Rows
        let grandGrossVatable = 0;
        let grandVat = 0;
        let grandAmount = 0;

        _data.forEach(record => {
            const row = worksheet.addRow([
                record.id,
                FormatDateToMDY(record.date),
                record.customerName1,
                record.terms,
                record.tin,
                record.salesman,
                record.grossVatable || 0,
                record.grossVatable || 0, // Vatable
                record.vat || 0,
                record.amount || 0
            ]);

            // Totals
            grandGrossVatable += record.grossVatable || 0;
            grandVat += record.vat || 0;
            grandAmount += record.amount || 0;

            // Numeric Formatting (Columns 7 - 10)
            for (let i = 7; i <= 10; i++) {
                row.getCell(i).numFmt = '#,##0.00';
            }
        });

        // 7. Footer Section (Grand Total)
        worksheet.addRow([]); // Blank row
        const totalRow = worksheet.addRow([
            'GRAND TOTAL', '', '', '', '', '',
            grandGrossVatable,
            grandGrossVatable,
            grandVat,
            grandAmount
        ]);

        totalRow.eachCell((cell, colIdx) => {
            cell.font = { bold: true };
            if (colIdx >= 7) {
                cell.numFmt = '#,##0.00';
                cell.border = { top: { style: 'thin' }, bottom: { style: 'double' } };
            }
        });

        // 8. Adjust Column Widths
        worksheet.columns = [
            { width: 12 }, // Doc No
            { width: 12 }, // Date
            { width: 30 }, // Customer Name
            { width: 12 }, // Terms
            { width: 15 }, // TIN
            { width: 20 }, // Salesman
            { width: 15 }, // Gross VATable
            { width: 15 }, // VATable
            { width: 15 }, // VAT Amount
            { width: 15 }, // Total Amount
        ];

        // 9. Export
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `Sales_Register_Doc_Summarized_${new Date().getTime()}.xlsx`);

    } catch (error) {
        console.error("Excel Export Error:", error);
        setFailMessage("Error generating Summarized Excel report");
    } finally {
        setLoading(false);
    }
  };

  const exportSalesRegisterByItemDetailedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
        setFailMessage("Please fill up Date From, Date To, and Company fields");
        return;
    }

    setLoading(true);

    try {
        const allData = await fetchReportData();
        // Use the grouped structure (Category > Item > Detail)
        const categories = allData?.byItemClassificationDetailed || [];

        if (categories.length === 0) {
            setFailMessage("No record found");
            setLoading(false);
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sales Register Detailed');

        // 1. REPORT HEADERS
        worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
        worksheet.addRow([company.address]);
        worksheet.addRow([`TIN: ${company.tin}`]);
        worksheet.addRow([]);
        worksheet.addRow(['SALES REGISTER BY ITEM CLASSIFICATION (DETAILED)']).font = { bold: true };
        worksheet.addRow([`Period Covered: ${FormatDateToMDY(dateFrom)} to ${FormatDateToMDY(dateTo)}`]);
        worksheet.addRow([`Date Printed: ${FormatDateToMDY(new Date())}`]);
        worksheet.addRow([]);

        // 2. DEFINE TABLE COLUMNS
        const tableHeader = [
            'Date', 'Doc No', 'Customer', 'Salesman', 'Qty', 'U/M', 
            'Unit Price', 'Disc %', 'Total Disc', 'Net Price', 
            'Gross VATable', 'VATable', 'VAT Amount', 'Net Amount'
        ];
        const headerRow = worksheet.addRow(tableHeader);

        // Header Styling
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '4472C4' } };
            cell.alignment = { horizontal: 'center' };
            cell.border = { bottom: { style: 'thin' } };
        });

        let grandGrossVatable = 0;
        let grandVatable = 0;
        let grandVat = 0;
        let grandNet = 0;

        // 3. DATA ITERATION (Category > Item Group > Detail Row)
        categories.forEach(category => {
            // Add Category Name Row (e.g. Aggregates)
            const catRow = worksheet.addRow([category.categoryName || "No Category"]);
            catRow.font = { bold: true, italic: true };
            catRow.getCell(1).alignment = { horizontal: 'left' };

            let categoryGrossVatable = 0;
            let categoryVatable = 0;
            let categoryVat = 0;
            let categoryNet = 0;

            category.items.forEach(itemGroup => {
                // Add Item Description Row (e.g. Aggregates 3/4 Crushed)
                const itemRowHeader = worksheet.addRow([itemGroup.itemDescription]);
                itemRowHeader.font = { italic: true };
                itemRowHeader.getCell(1).alignment = { horizontal: 'left' };

                itemGroup.details.forEach(detail => {
                    const row = worksheet.addRow([
                        FormatDateToMDY(detail.date),
                        detail.docNo?.split('-').pop(),
                        detail.customer,
                        detail.salesman,
                        detail.quantity,
                        detail.uomName,
                        detail.unitPrice,
                        detail.discountPercent || 0,
                        detail.totalDiscount || 0,
                        detail.netPrice,
                        detail.vaTableSales || 0, // Gross VATable
                        detail.vaTableSales || 0, // VATable
                        detail.vat || 0,
                        detail.totalAmount || 0
                    ]);

                    // Format numbers
                    [5, 7, 8, 9, 10, 11, 12, 13, 14].forEach(col => {
                        row.getCell(col).numFmt = '#,##0.00';
                    });

                    categoryGrossVatable += (detail.vaTableSales || 0);
                    categoryVatable += (detail.vaTableSales || 0);
                    categoryVat += (detail.vat || 0);
                    categoryNet += (detail.totalAmount || 0);
                });
            });

            // 4. CATEGORY SUB-TOTAL
            const subTotalRow = worksheet.addRow([
                'Item Classification Sub-Total:', '', '', '', '', '', '', '', '', '',
                categoryGrossVatable,
                categoryVatable,
                categoryVat,
                categoryNet
            ]);

            subTotalRow.font = { bold: true };
            [11, 12, 13, 14].forEach(col => {
                subTotalRow.getCell(col).numFmt = '#,##0.00';
                subTotalRow.getCell(col).border = { top: { style: 'thin' } };
            });

            grandGrossVatable += categoryGrossVatable;
            grandVatable += categoryVatable;
            grandVat += categoryVat;
            grandNet += categoryNet;

            worksheet.addRow([]); // Blank row between categories
        });

        // 5. GRAND TOTAL
        const grandTotalRow = worksheet.addRow([
            'GRAND TOTAL:', '', '', '', '', '', '', '', '', '',
            grandGrossVatable,
            grandVatable,
            grandVat,
            grandNet
        ]);

        grandTotalRow.font = { bold: true, size: 12 };
        [11, 12, 13, 14].forEach(col => {
            grandTotalRow.getCell(col).numFmt = '#,##0.00';
            grandTotalRow.getCell(col).border = { top: { style: 'thin' }, bottom: { style: 'double' } };
        });

        // 6. COLUMN WIDTHS
        worksheet.columns = [
            { width: 12 }, // Date
            { width: 12 }, // Doc No
            { width: 25 }, // Customer
            { width: 20 }, // Salesman
            { width: 10 }, // Qty
            { width: 10 }, // U/M
            { width: 12 }, // Unit Price
            { width: 10 }, // Disc %
            { width: 12 }, // Total Disc
            { width: 12 }, // Net Price
            { width: 15 }, // Gross VATable
            { width: 15 }, // VATable
            { width: 12 }, // VAT Amount
            { width: 15 }, // Net Amount
        ];

        // 7. EXPORT
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `Sales_Register_By_Item_Detailed_${new Date().getTime()}.xlsx`);

    } catch (error) {
        console.error("Excel Export Error:", error);
        setFailMessage("Error generating Excel report");
    } finally {
        setLoading(false);
    }
  };

  const exportSalesRegisterByItemSummarizedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
        setFailMessage("Please fill up Date From, Date To, and Company fields");
        return;
    }

    setLoading(true);

    try {
        const allData = await fetchReportData();
        // The summarized version typically uses the pre-aggregated item totals
        const _data = allData?.byItemDetailed || [];

        if (_data.length === 0) {
            setFailMessage("No record found");
            setLoading(false);
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Summarized By Item');

        // 1. REPORT HEADERS
        worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
        worksheet.addRow([company.address]);
        worksheet.addRow([`TIN: ${company.tin}`]);
        worksheet.addRow([]);
        worksheet.addRow(['SALES REGISTER BY ITEM (SUMMARIZED)']).font = { bold: true };
        worksheet.addRow([`Period Covered: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
        worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
        worksheet.addRow([]);

        // 2. DEFINE TABLE COLUMNS
        const headerRow = worksheet.addRow([
            'Item Description', 
            'Quantity', 
            'U/M', 
            'Sales Amount', 
            'Sales Return', 
            'Net Amount'
        ]);

        // Header Styling
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '4472C4' } };
            cell.alignment = { horizontal: 'center' };
        });

        let grandSalesAmount = 0;
        let grandSalesReturn = 0; // Usually 0 based on your PDF logic
        let grandNetAmount = 0;

        // 3. DATA ROWS
        _data.forEach(item => {
            const salesAmt = item.totalAmount || 0;
            const returnAmt = 0; // Following PDF logic where return is 0
            const netAmt = salesAmt - returnAmt;

            const row = worksheet.addRow([
                item.description || "Unknown Item",
                item.totalQuantity || 0,
                item.uomName || "",
                salesAmt,
                returnAmt,
                netAmt
            ]);

            // Formatting numbers
            [2, 4, 5, 6].forEach(col => {
                row.getCell(col).numFmt = '#,##0.00';
            });

            grandSalesAmount += salesAmt;
            grandSalesReturn += returnAmt;
            grandNetAmount += netAmt;
        });

        // 4. GRAND TOTAL FOOTER
        worksheet.addRow([]); // Blank row
        const totalRow = worksheet.addRow([
            'GRAND TOTAL', 
            '', 
            '', 
            grandSalesAmount, 
            grandSalesReturn, 
            grandNetAmount
        ]);

        totalRow.font = { bold: true, size: 11 };
        [4, 5, 6].forEach(col => {
            totalRow.getCell(col).numFmt = '#,##0.00';
            totalRow.getCell(col).border = { top: { style: 'thin' }, bottom: { style: 'double' } };
        });

        // 5. ADJUST COLUMN WIDTHS
        worksheet.columns = [
            { width: 40 }, // Item Description
            { width: 15 }, // Quantity
            { width: 10 }, // U/M
            { width: 18 }, // Sales Amount
            { width: 18 }, // Sales Return
            { width: 18 }, // Net Amount
        ];

        // 6. EXPORT FILE
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `Sales_Register_Item_Summarized_${new Date().getTime()}.xlsx`);

    } catch (error) {
        console.error("Excel Export Error:", error);
        setFailMessage("Error generating Summarized Excel report");
    } finally {
        setLoading(false);
    }
  };

  const exportSalesRegisterByItemClassificationDetailedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
        setFailMessage("Please fill up Date From, Date To, and Company fields");
        return;
    }

    setLoading(true);

    try {
        const allData = await fetchReportData();
        const categories = allData?.byItemClassificationDetailed || [];

        if (categories.length === 0) {
            setFailMessage("No record found");
            setLoading(false);
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sales Register Detailed');

        // 1. REPORT HEADERS
        worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
        worksheet.addRow([company.address]);
        worksheet.addRow([`TIN: ${company.tin}`]);
        worksheet.addRow([]);
        worksheet.addRow(['SALES REGISTER BY ITEM CLASSIFICATION (DETAILED)']).font = { bold: true };
        worksheet.addRow([`Period Covered: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
        worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
        worksheet.addRow([]);

        // 2. DEFINE TABLE COLUMNS
        const tableHeader = [
            'Date', 'Doc No', 'Customer', 'Salesman', 'Qty', 'U/M', 
            'Gross Amount', 'Discount', 'Gross VATable', 'VATable', 
            'VAT Amount', 'Net Amount'
        ];
        const headerRow = worksheet.addRow(tableHeader);

        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '4472C4' } };
            cell.alignment = { horizontal: 'center' };
            cell.border = { bottom: { style: 'thin' } };
        });

        let grandGrossAmt = 0;
        let grandDiscount = 0;
        let grandGrossVatable = 0;
        let grandVatable = 0;
        let grandVat = 0;
        let grandNet = 0;

        // 3. DATA ITERATION (Category > Item Group > Detail)
        categories.forEach(category => {
            // Category Row
            const catRow = worksheet.addRow([category.categoryName || "No Category"]);
            catRow.font = { bold: true, italic: true };

            let catGrossAmt = 0;
            let catDiscount = 0;
            let catGrossVat = 0;
            let catVatable = 0;
            let catVat = 0;
            let catNet = 0;

            category.items.forEach(itemGroup => {
                // Item Row Header
                const itemHeaderRow = worksheet.addRow([itemGroup.itemDescription]);
                itemHeaderRow.font = { italic: true };

                itemGroup.details.forEach(detail => {
                    const row = worksheet.addRow([
                        FormatDateToMDY(detail.date),
                        detail.docId || "",
                        detail.customer,
                        detail.salesman,
                        detail.quantity,
                        detail.uomName,
                        detail.netPrice, // In your code this maps to Gross Amount
                        detail.totalDiscount || 0,
                        detail.vaTableSales || 0,
                        detail.vaTableSales || 0,
                        detail.vat || 0,
                        detail.totalAmount || 0
                    ]);

                    // Numeric Formatting
                    [5, 7, 8, 9, 10, 11, 12].forEach(col => {
                        row.getCell(col).numFmt = '#,##0.00';
                    });

                    // Accumulate Category Totals
                    catGrossAmt += (detail.netPrice || 0);
                    catDiscount += (detail.totalDiscount || 0);
                    catGrossVat += (detail.vaTableSales || 0);
                    catVatable += (detail.vaTableSales || 0);
                    catVat += (detail.vat || 0);
                    catNet += (detail.totalAmount || 0);
                });
            });

            // 4. CATEGORY SUB-TOTAL
            const subTotalRow = worksheet.addRow([
                'Item Classification Sub-Total:', '', '', '', '', '',
                catGrossAmt,
                catDiscount,
                catGrossVat,
                catVatable,
                catVat,
                catNet
            ]);

            subTotalRow.font = { bold: true };
            [7, 8, 9, 10, 11, 12].forEach(col => {
                subTotalRow.getCell(col).numFmt = '#,##0.00';
                subTotalRow.getCell(col).border = { top: { style: 'thin' } };
            });

            // Accumulate Grand Totals
            grandGrossAmt += catGrossAmt;
            grandDiscount += catDiscount;
            grandGrossVatable += catGrossVat;
            grandVatable += catVatable;
            grandVat += catVat;
            grandNet += catNet;

            worksheet.addRow([]); // Spacer
        });

        // 5. GRAND TOTAL
        const grandTotalRow = worksheet.addRow([
            'GRAND TOTAL:', '', '', '', '', '',
            grandGrossAmt,
            grandDiscount,
            grandGrossVatable,
            grandVatable,
            grandVat,
            grandNet
        ]);

        grandTotalRow.font = { bold: true, size: 11 };
        [7, 8, 9, 10, 11, 12].forEach(col => {
            grandTotalRow.getCell(col).numFmt = '#,##0.00';
            grandTotalRow.getCell(col).border = { top: { style: 'thin' }, bottom: { style: 'double' } };
        });

        // 6. COLUMN WIDTHS
        worksheet.columns = [
            { width: 12 }, // Date
            { width: 12 }, // Doc No
            { width: 25 }, // Customer
            { width: 20 }, // Salesman
            { width: 10 }, // Qty
            { width: 10 }, // U/M
            { width: 15 }, // Gross Amt
            { width: 12 }, // Discount
            { width: 15 }, // Gross VATable
            { width: 15 }, // VATable
            { width: 12 }, // VAT Amount
            { width: 15 }, // Net Amount
        ];

        // 7. EXPORT
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `Item_Classification_Detailed_${FormatDateToMDY(new Date())}.xlsx`);

    } catch (error) {
        console.error("Excel Error:", error);
        setFailMessage("Error generating Excel report");
    } finally {
        setLoading(false);
    }
  };

  const exportSalesRegisterByItemClassificationSummarizedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
        setFailMessage("Please fill up Date From, Date To, and Company fields");
        return;
    }

    setLoading(true);

    try {
        const allData = await fetchReportData();
        const categories = allData?.byItemClassificationDetailed || [];

        if (categories.length === 0) {
            setFailMessage("No record found");
            setLoading(false);
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Summarized By Classification');

        // 1. REPORT HEADERS
        worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
        worksheet.addRow([company.address]);
        worksheet.addRow([`TIN: ${company.tin}`]);
        worksheet.addRow([]);
        worksheet.addRow(['SALES REGISTER BY ITEM CLASSIFICATION (SUMMARIZED)']).font = { bold: true };
        worksheet.addRow([`Period Covered: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
        worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
        worksheet.addRow([]);

        // 2. DEFINE TABLE COLUMNS (Matching the Summarized PDF Layout)
        const tableHeader = [
            'Item Description', 
            'Quantity', 
            'U/M', 
            'Gross Amount', 
            'Discount', 
            'Gross VATable', 
            'VATable', 
            'VAT Amount', 
            'Net Amount'
        ];
        const headerRow = worksheet.addRow(tableHeader);

        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '4472C4' } };
            cell.alignment = { horizontal: 'center' };
        });

        let grandGrossAmt = 0;
        let grandDiscount = 0;
        let grandGrossVatable = 0;
        let grandVatable = 0;
        let grandVat = 0;
        let grandNet = 0;

        // 3. DATA ITERATION
        categories.forEach(category => {
            // Category Header Row
            const catRow = worksheet.addRow([category.categoryName || "No Category"]);
            catRow.font = { bold: true, italic: true };

            let catGrossAmt = 0;
            let catDiscount = 0;
            let catGrossVat = 0;
            let catVatable = 0;
            let catVat = 0;
            let catNet = 0;

            category.items.forEach(itemGroup => {
                // In a summarized report, we roll up the details per item group
                let itemQty = 0;
                let itemGross = 0;
                let itemDisc = 0;
                let itemVATable = 0;
                let itemVAT = 0;
                let itemNet = 0;
                const uom = itemGroup.details[0]?.uomName || "";

                itemGroup.details.forEach(detail => {
                    itemQty += (detail.quantity || 0);
                    itemGross += (detail.netPrice || 0);
                    itemDisc += (detail.totalDiscount || 0);
                    itemVATable += (detail.vaTableSales || 0);
                    itemVAT += (detail.vat || 0);
                    itemNet += (detail.totalAmount || 0);
                });

                const row = worksheet.addRow([
                    itemGroup.itemDescription,
                    itemQty,
                    uom,
                    itemGross,
                    itemDisc,
                    itemVATable, // Gross VATable
                    itemVATable, // VATable
                    itemVAT,
                    itemNet
                ]);

                // Formatting numbers
                [2, 4, 5, 6, 7, 8, 9].forEach(col => {
                    row.getCell(col).numFmt = '#,##0.00';
                });

                // Add to category totals
                catGrossAmt += itemGross;
                catDiscount += itemDisc;
                catGrossVat += itemVATable;
                catVatable += itemVATable;
                catVat += itemVAT;
                catNet += itemNet;
            });

            // 4. CATEGORY SUB-TOTAL
            const subTotalRow = worksheet.addRow([
                'Item Classification Sub-Total:', '', '',
                catGrossAmt,
                catDiscount,
                catGrossVat,
                catVatable,
                catVat,
                catNet
            ]);

            subTotalRow.font = { bold: true };
            [4, 5, 6, 7, 8, 9].forEach(col => {
                subTotalRow.getCell(col).numFmt = '#,##0.00';
                subTotalRow.getCell(col).border = { top: { style: 'thin' } };
            });

            grandGrossAmt += catGrossAmt;
            grandDiscount += catDiscount;
            grandGrossVatable += catGrossVat;
            grandVatable += catVatable;
            grandVat += catVat;
            grandNet += catNet;

            worksheet.addRow([]); // Space
        });

        // 5. GRAND TOTAL
        const grandTotalRow = worksheet.addRow([
            'GRAND TOTAL:', '', '',
            grandGrossAmt,
            grandDiscount,
            grandGrossVatable,
            grandVatable,
            grandVat,
            grandNet
        ]);

        grandTotalRow.font = { bold: true, size: 11 };
        [4, 5, 6, 7, 8, 9].forEach(col => {
            grandTotalRow.getCell(col).numFmt = '#,##0.00';
            grandTotalRow.getCell(col).border = { top: { style: 'thin' }, bottom: { style: 'double' } };
        });

        // 6. COLUMN WIDTHS
        worksheet.columns = [
            { width: 35 }, // Item Description
            { width: 12 }, // Qty
            { width: 10 }, // U/M
            { width: 15 }, // Gross Amount
            { width: 15 }, // Discount
            { width: 15 }, // Gross VATable
            { width: 15 }, // VATable
            { width: 15 }, // VAT Amount
            { width: 15 }, // Net Amount
        ];

        // 7. EXPORT
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `Item_Classification_Summarized_${new Date().getTime()}.xlsx`);

    } catch (error) {
        console.error("Excel Export Error:", error);
        setFailMessage("Error generating Summarized Excel report");
    } finally {
        setLoading(false);
    }
  };

  const exportSalesRegisterByPaymentReceivedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
        setFailMessage("Please fill up Date From, Date To, and Company fields");
        return;
    }

    setLoading(true);

    try {
        const allData = await fetchReportData();
        const categories = allData?.byItemClassificationDetailed || [];

        if (categories.length === 0) {
            setFailMessage("No record found");
            setLoading(false);
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sales Register Detailed');

        // 1. REPORT HEADERS
        worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
        worksheet.addRow([company.address]);
        worksheet.addRow([`TIN: ${company.tin}`]);
        worksheet.addRow([]);
        worksheet.addRow(['SALES REGISTER BY ITEM CLASSIFICATION (DETAILED)']).font = { bold: true };
        worksheet.addRow([`Period Covered: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
        worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
        worksheet.addRow([]);

        // 2. DEFINE TABLE COLUMNS
        const tableHeader = [
            'Date', 'Doc No', 'Customer', 'Salesman', 'Qty', 'U/M', 
            'Gross Amount', 'Discount', 'Gross VATable', 'VATable', 
            'VAT Amount', 'Net Amount'
        ];
        const headerRow = worksheet.addRow(tableHeader);

        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '4472C4' } };
            cell.alignment = { horizontal: 'center' };
            cell.border = { bottom: { style: 'thin' } };
        });

        let grandGrossAmt = 0;
        let grandDiscount = 0;
        let grandGrossVatable = 0;
        let grandVatable = 0;
        let grandVat = 0;
        let grandNet = 0;

        // 3. DATA ITERATION (Category > Item Group > Detail)
        categories.forEach(category => {
            // Category Row
            const catRow = worksheet.addRow([category.categoryName || "No Category"]);
            catRow.font = { bold: true, italic: true };

            let catGrossAmt = 0;
            let catDiscount = 0;
            let catGrossVat = 0;
            let catVatable = 0;
            let catVat = 0;
            let catNet = 0;

            category.items.forEach(itemGroup => {
                // Item Row Header
                const itemHeaderRow = worksheet.addRow([itemGroup.itemDescription]);
                itemHeaderRow.font = { italic: true };

                itemGroup.details.forEach(detail => {
                    const row = worksheet.addRow([
                        FormatDateToMDY(detail.date),
                        detail.docId || "",
                        detail.customer,
                        detail.salesman,
                        detail.quantity,
                        detail.uomName,
                        detail.netPrice, // In your code this maps to Gross Amount
                        detail.totalDiscount || 0,
                        detail.vaTableSales || 0,
                        detail.vaTableSales || 0,
                        detail.vat || 0,
                        detail.totalAmount || 0
                    ]);

                    // Numeric Formatting
                    [5, 7, 8, 9, 10, 11, 12].forEach(col => {
                        row.getCell(col).numFmt = '#,##0.00';
                    });

                    // Accumulate Category Totals
                    catGrossAmt += (detail.netPrice || 0);
                    catDiscount += (detail.totalDiscount || 0);
                    catGrossVat += (detail.vaTableSales || 0);
                    catVatable += (detail.vaTableSales || 0);
                    catVat += (detail.vat || 0);
                    catNet += (detail.totalAmount || 0);
                });
            });

            // 4. CATEGORY SUB-TOTAL
            const subTotalRow = worksheet.addRow([
                'Item Classification Sub-Total:', '', '', '', '', '',
                catGrossAmt,
                catDiscount,
                catGrossVat,
                catVatable,
                catVat,
                catNet
            ]);

            subTotalRow.font = { bold: true };
            [7, 8, 9, 10, 11, 12].forEach(col => {
                subTotalRow.getCell(col).numFmt = '#,##0.00';
                subTotalRow.getCell(col).border = { top: { style: 'thin' } };
            });

            // Accumulate Grand Totals
            grandGrossAmt += catGrossAmt;
            grandDiscount += catDiscount;
            grandGrossVatable += catGrossVat;
            grandVatable += catVatable;
            grandVat += catVat;
            grandNet += catNet;

            worksheet.addRow([]); // Spacer
        });

        // 5. GRAND TOTAL
        const grandTotalRow = worksheet.addRow([
            'GRAND TOTAL:', '', '', '', '', '',
            grandGrossAmt,
            grandDiscount,
            grandGrossVatable,
            grandVatable,
            grandVat,
            grandNet
        ]);

        grandTotalRow.font = { bold: true, size: 11 };
        [7, 8, 9, 10, 11, 12].forEach(col => {
            grandTotalRow.getCell(col).numFmt = '#,##0.00';
            grandTotalRow.getCell(col).border = { top: { style: 'thin' }, bottom: { style: 'double' } };
        });

        // 6. COLUMN WIDTHS
        worksheet.columns = [
            { width: 12 }, // Date
            { width: 12 }, // Doc No
            { width: 25 }, // Customer
            { width: 20 }, // Salesman
            { width: 10 }, // Qty
            { width: 10 }, // U/M
            { width: 15 }, // Gross Amt
            { width: 12 }, // Discount
            { width: 15 }, // Gross VATable
            { width: 15 }, // VATable
            { width: 12 }, // VAT Amount
            { width: 15 }, // Net Amount
        ];

        // 7. EXPORT
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `Item_Classification_Detailed_${FormatDateToMDY(new Date())}.xlsx`);

    } catch (error) {
        console.error("Excel Error:", error);
        setFailMessage("Error generating Excel report");
    } finally {
        setLoading(false);
    }
  };
//#endregion






//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasSalesRegister) {
    return <NoAccess />;
  }
//#endregion






//#region UI
  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
              <HistoryEduIcon fontSize="large" className="text-theme-color" />
              {`Sales Register`}
            </h2>
            <p className="text-gray-500 mt-1">Report of all Sales Invoices.</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Company <span className="text-red-500">*</span>
            </label>
            <CompanySelect data={company} setData={setCompany} isEditable={true}/>
          </div>
          
          <div className="max-w-2xl">
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Customer 
            </label>
            <div className="flex flex-row items-center">
              <input
                type="text"
                placeholder="Select Customer"
                className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                value={`${customer ? `${customer?.customerId} - ${customer?.name1}` : ""}`}
                readOnly
              />
              {!customer ?
                <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openCustomerSelect}>
                  <PersonSearchIcon className="text-white"/>
                </button> 
                :
                <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setCustomer(null)}>
                  <RemoveCircleIcon className="text-white"/>
                </button>
              }
            </div>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Date From
            </label>
            <DateSelect data={dateFrom} setData={setDateFrom} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Date To
            </label>
            <DateSelect data={dateTo} setData={setDateTo} isEditable={true}/>
          </div>
          
          <div className="max-w-2xl">
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Item 
            </label>
            <div className="flex flex-row items-center">
              <input
                type="text"
                placeholder="Select Item"
                className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                value={`${item ? `${item?.itemCode} - ${item?.itemDescription}` : ""}`}
                readOnly
              />
              {!item ?
                <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openItemSelect}>
                  <SearchIcon className="text-white"/>
                </button> 
                :
                <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setItem(null)}>
                  <RemoveCircleIcon className="text-white"/>
                </button>
              }
            </div>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Item Classification 
            </label>
            <CategorySelect data={category} setData={setCategory} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Salesman 
            </label>
            <SalesmanSelect data={salesman} setData={setSalesman} customer={customer} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Terms
            </label>
            <TermsSelect data={terms} setData={setTerms} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Document No.
            </label>
            <SalesInvoiceOptionalCustomerSelect data={invoice} setData={setInvoice} isEditable={true} customerId={customer ? customer?.customerId : "All"}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Time of Departure
            </label>
            <DateTimeSelect data={timeOfDeparture} setData={setTimeOfDeparture} isEditable={true}/>
          </div>

        </div>

        <div className="mt-5 p-6 bg-white rounded-2xl shadow-sm border border-gray-100">
          <h2 className="text-lg font-bold text-gray-800 mb-6 px-2">Generate Sales Registers</h2>

          {/* Header Row - Hidden on Mobile */}
          <div className="hidden md:grid grid-cols-12 gap-4 px-4 mb-2 text-xs font-black uppercase tracking-widest text-gray-400">
            <div className="col-span-2">Report Category</div>
            <div className="col-span-5">PDF Reports</div>
            <div className="col-span-5 border-l border-gray-100">Excel Reports</div>
          </div>

          <div className="space-y-3">
            {[
              { 
                label: "By Customer", 
                pdf_detailed: generateSalesRegisterByCustomerDetailedHandleClick, 
                pdf_summarized: generateSalesRegisterByCustomerSummarizedHandleClick, 
                pdf_extra: generateSalesRegisterByCustomerSummarizedWithPercentageHandleClick,
                excel_detailed: exportSalesRegisterByCustomerDetailedExcel, // Replace with your Excel function
                excel_summarized: exportSalesRegisterByCustomerSummarizedExcel, // Replace with your Excel function
                excel_extra: exportSalesRegisterByCustomerSummarizedWithPercentageExcel, // Replace with your Excel function
              },
              { 
                label: "By Date", 
                pdf_detailed: generateSalesRegisterByDateDetailedHandleClick, 
                pdf_summarized: generateSalesRegisterByDateSummarizedHandleClick,
                excel_detailed: exportSalesRegisterByDateDetailedExcel, 
                excel_summarized: exportSalesRegisterByDateSummarizedExcel 
              },
              { 
                label: "By Doc No", 
                pdf_detailed: generateSalesRegisterByDocDetailedHandleClick, 
                pdf_summarized: generateSalesRegisterByDocSummarizedHandleClick,
                excel_detailed: exportSalesRegisterByDocDetailedExcel, 
                excel_summarized: exportSalesRegisterByDocSummarizedExcel
              },
              { 
                label: "By Item", 
                pdf_detailed: generateSalesRegisterByItemDetailedHandleClick, 
                pdf_summarized: generateSalesRegisterByItemSummarizedHandleClick,
                excel_detailed: exportSalesRegisterByItemDetailedExcel, 
                excel_summarized: exportSalesRegisterByItemSummarizedExcel
              },
              { 
                label: "By Item Classification", 
                pdf_detailed: generateSalesRegisterByItemClassificationDetailedHandleClick, 
                pdf_summarized: generateSalesRegisterByItemClassificationSummarizedHandleClick,
                excel_detailed: exportSalesRegisterByItemClassificationDetailedExcel, 
                excel_summarized: exportSalesRegisterByItemClassificationSummarizedExcel
              },
              { 
                label: "By Payment Received", 
                pdf_detailed: generateSalesRegisterByPaymentReceivedHandleClick, 
                excel_detailed: exportSalesRegisterByPaymentReceivedExcel, 
              },
            ].map((group, idx) => (
              <div key={idx} className="grid grid-cols-1 md:grid-cols-12 items-center gap-4 p-4 rounded-xl border border-gray-100 hover:bg-gray-50 transition-colors">
                
                {/* Label */}
                <div className="col-span-2">
                  <span className="text-sm font-bold text-gray-700">{group.label}</span>
                </div>

                {/* PDF Column */}
                <div className="col-span-5 flex flex-wrap gap-2">
                  {group.pdf_detailed &&
                    <button 
                      onClick={group.pdf_detailed} 
                      className="flex items-center gap-2 bg-red-50 text-red-700 border border-red-100 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-red-100 transition-all active:scale-95"
                      title="Download PDF Detailed"
                    >
                      <RestartAltIcon sx={{ fontSize: 16 }} /> Detailed
                    </button>
                  }

                  {group.pdf_summarized &&
                    <button 
                      onClick={group.pdf_summarized} 
                      className="flex items-center gap-2 bg-white text-gray-700 border border-gray-300 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-gray-50 transition-all active:scale-95"
                    >
                      Summarized
                    </button>
                  }

                  {group.pdf_extra && (
                    <button 
                      onClick={group.pdf_extra} 
                      className="flex items-center gap-2 bg-blue-50 text-blue-700 border border-blue-100 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-blue-100 transition-all active:scale-95"
                    >
                      Summarized w/ %
                    </button>
                  )}
                </div>

                {/* Excel Column */}
                <div className="col-span-5 flex flex-wrap gap-2 border-t md:border-t-0 md:border-l border-gray-100 pt-3 md:pt-0">
                  {group.excel_detailed &&
                    <button 
                      onClick={group.excel_detailed} 
                      className="flex items-center gap-2 bg-green-600 text-white px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-green-700 shadow-sm transition-all active:scale-95"
                    >
                      Excel Detailed
                    </button>
                  }
                  
                  {group.excel_summarized &&
                    <button 
                      onClick={group.excel_summarized} 
                      className="flex items-center gap-2 bg-green-50 text-green-700 border border-green-200 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-green-100 transition-all active:scale-95"
                    >
                      Excel Summ.
                    </button>
                  }
                  
                  
                  { group.excel_extra &&
                    <button 
                      onClick={group.excel_extra} 
                      className="flex items-center gap-2 bg-green-50 text-green-700 border border-green-200 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-green-100 transition-all active:scale-95"
                    >
                      Excel Summ. w/ %
                    </button>
                  }
                </div>

              </div>
            ))}
          </div>
        </div>
      </div>
      
      <CustomerSelect 
        visible={showCustomerSelect} 
        onClose={closeCustomerSelect}
        modalName={"Select Customer"}
        data={customer} setData={setCustomer}
      />
      
      <ItemSelect 
        visible={showItemSelect} 
        onClose={closeItemSelect}
        modalName={"Select Item"}
        data={item} setData={setItem}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
//#endregion
}